<template>
  <div class="page-content">
    <v-card class="mx-auto elevation-2 tabs-card" style="margin-top: 16px;">
      <v-container fluid class="pa-2">
        <v-row align="center" justify="space-between" no-gutters>
          <v-col cols="auto">
            <v-tabs
              v-model="activeTab"
              class="dashboard-tab"
              show-arrows
              next-icon="mdi-arrow-right-bold-box-outline"
              prev-icon="mdi-arrow-left-bold-box-outline"
              style="background-color: white; color: #2C74B3;"
            >
              <v-tab v-if="!isSatelliteMonitor" value="studio">Studio</v-tab>
              <v-tab v-if="!isSatelliteMonitor" value="morning">Morning</v-tab>
              <v-tab v-if="!isSatelliteMonitor" value="evening">Evening</v-tab>
              <v-tab v-if="!isSatelliteMonitor" value="night">Night</v-tab>
              <v-tab value="satellite">Satellite</v-tab>
              <v-tab v-if="!isSatelliteMonitor" value="active">Active</v-tab>
            </v-tabs>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-row style="margin-top: 16px;">
      <v-col cols="12">
        <v-card
          class="elevation-4 hours-dashboard-card"
          :class="{ 'hours-dashboard-card-collapsed': isHoursDashboardCollapsed }"
        >
          <div class="hours-dashboard-header">
            <div class="hours-dashboard-title-wrap">
              <span class="hours-dashboard-title">Hours Dashboard</span>
              <v-icon
                class="hours-dashboard-toggle"
                size="24"
                @click="toggleHoursDashboard"
              >
                {{ isHoursDashboardCollapsed ? 'mdi-chevron-down' : 'mdi-chevron-up' }}
              </v-icon>
            </div>
            <div class="hours-dashboard-actions">
              <v-btn
                v-if="!isHoursDashboardCollapsed && !isEditingPayStructure"
                class="hours-dashboard-edit-btn"
                size="small"
                variant="outlined"
                @click="startEditingPayStructure"
              >
                Edit
              </v-btn>
              <template v-if="!isHoursDashboardCollapsed && isEditingPayStructure">
                <v-btn
                  class="hours-dashboard-edit-btn"
                  size="small"
                  variant="outlined"
                  :loading="savingPayStructure"
                  @click="savePayStructure"
                >
                  Save
                </v-btn>
                <v-btn
                  class="hours-dashboard-cancel-btn"
                  size="small"
                  variant="text"
                  :disabled="savingPayStructure"
                  @click="cancelEditingPayStructure"
                >
                  Cancel
                </v-btn>
              </template>
            </div>
          </div>
          <v-expand-transition>
            <div v-show="!isHoursDashboardCollapsed" class="hours-dashboard-body">
                <div class="hours-dashboard-reference">
                <div class="hours-pay-structure-panels">
                  <div class="hours-pay-structure-panel">
                    <div class="hours-pay-structure-panel-title">
                      <span>Main Sites</span>
                      <small>{{ mainPayableDays }} Working Days / {{ mainPeriodDays }} Period Days</small>
                    </div>
                    <div class="hours-pay-structure-table">
                      <div class="hours-pay-structure-head">%</div>
                      <div class="hours-pay-structure-head">Daily Hours</div>
                      <div class="hours-pay-structure-head">Period Hours</div>
                      <template
                        v-for="(row, index) in displayedPayStructureRows"
                        :key="`main-pay-structure-${index}-${row.percentage}`"
                      >
                        <div class="hours-pay-structure-cell">
                          <v-text-field
                            v-if="isEditingPayStructure"
                            v-model.number="editablePayStructureRows[index].percentage"
                            type="number"
                            density="compact"
                            variant="outlined"
                            hide-details
                            class="hours-pay-structure-input"
                          ></v-text-field>
                          <strong v-else>{{ formatHoursTotal(row.percentage) }}%</strong>
                        </div>
                        <div class="hours-pay-structure-cell">
                          <v-text-field
                            v-if="isEditingPayStructure"
                            v-model.number="editablePayStructureRows[index].mainDailyHours"
                            type="number"
                            min="0"
                            step="0.25"
                            density="compact"
                            variant="outlined"
                            hide-details
                            class="hours-pay-structure-input"
                          ></v-text-field>
                          <span v-else>{{ formatHoursTotal(row.mainDailyHours) }}</span>
                        </div>
                        <div class="hours-pay-structure-cell">
                          <span>{{ formatHoursTotal(getMainPeriodHours(row)) }}</span>
                        </div>
                      </template>
                    </div>
                  </div>

                  <div class="hours-pay-structure-panel">
                    <div class="hours-pay-structure-panel-title">
                      <span>Chaturbate</span>
                      <small v-if="hasChaturbatePeriod">{{ chaturbatePayableDays }} Working Days / {{ dashboardChaturbateDays }} Period Days</small>
                      <small v-else>No CB Payment</small>
                    </div>
                    <div v-if="hasChaturbatePeriod" class="hours-pay-structure-table">
                      <div class="hours-pay-structure-head">%</div>
                      <div class="hours-pay-structure-head">Daily Hours</div>
                      <div class="hours-pay-structure-head">Period Hours</div>
                      <template
                        v-for="(row, index) in displayedPayStructureRows"
                        :key="`cb-pay-structure-${index}-${row.percentage}`"
                      >
                        <div class="hours-pay-structure-cell">
                          <v-text-field
                            v-if="isEditingPayStructure"
                            v-model.number="editablePayStructureRows[index].percentage"
                            type="number"
                            density="compact"
                            variant="outlined"
                            hide-details
                            class="hours-pay-structure-input"
                          ></v-text-field>
                          <strong v-else>{{ formatHoursTotal(row.percentage) }}%</strong>
                        </div>
                        <div class="hours-pay-structure-cell">
                          <v-text-field
                            v-if="isEditingPayStructure"
                            v-model.number="editablePayStructureRows[index].cbDailyHours"
                            type="number"
                            min="0"
                            step="0.25"
                            density="compact"
                            variant="outlined"
                            hide-details
                            class="hours-pay-structure-input"
                          ></v-text-field>
                          <span v-else>{{ formatHoursTotal(row.cbDailyHours) }}</span>
                        </div>
                        <div class="hours-pay-structure-cell">
                          <span>{{ formatHoursTotal(getCbPeriodHours(row)) }}</span>
                        </div>
                      </template>
                    </div>
                    <div v-else class="hours-pay-structure-skipped">
                      <v-icon size="28">mdi-calendar-arrow-right</v-icon>
                      <div>
                        <strong>No Chaturbate payment in this period</strong>
                        <span v-if="nextChaturbatePeriodName">
                          Chaturbate continues in {{ nextChaturbatePeriodName }}.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </v-expand-transition>
        </v-card>
      </v-col>
    </v-row>

    <v-row style="margin-top: 10px;">
      <v-col cols="12" md="3">
        <v-card
          :class="['elevation-2', activeCard === 'viewModel' ? 'active-card' : '']"
          style="min-height: 180px; border-radius: 6px;"
          @click="setActiveCard('viewModel')"
        >
          <v-card-title style="position: relative; display: flex; align-items: center; padding: 8px 16px;">
            <v-icon style="margin-right: 8px; font-size: 28px;">mdi-dance-pole</v-icon>
            <span style="position: absolute; left: 50%; transform: translateX(-50%); font-size: 16px; font-weight: 600;">View Model</span>
          </v-card-title>
          <v-card-text style="padding: 4px 16px; padding-bottom: 40px;">
            <v-select
              v-model="modelFilter"
              :items="models"
              item-title="label"
              item-value="id"
              label="Select Model"
              outlined
              hide-details
              :disabled="models.length === 0"
              style="font-size: 14px;"
            ></v-select>
          </v-card-text>
          <v-card-actions style="justify-content: center; margin-top: -16px; margin-bottom: 12px; position: absolute; bottom: 0; width: 100%;">
            <v-btn
              :class="['btn-secondary', activeCard === 'viewModel' ? 'active-button' : '']"
              :disabled="!modelFilter"
              @click.stop="addModelChip"
              style="padding: 0 40px; height: 36px; font-size: 14px; background-color: #1976d2; color: white;"
            >
              View
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="3">
        <v-card
          :class="['elevation-2', activeCard === 'viewSite' ? 'active-card' : '']"
          style="min-height: 180px; border-radius: 6px;"
          @click="setActiveCard('viewSite')"
        >
          <v-card-title style="position: relative; display: flex; align-items: center; padding: 8px 16px;">
            <v-icon style="margin-right: 8px; font-size: 28px;">mdi-web</v-icon>
            <span style="position: absolute; left: 50%; transform: translateX(-50%); font-size: 16px; font-weight: 600;">View Site</span>
          </v-card-title>
          <v-card-text style="padding: 4px 16px; padding-bottom: 40px;">
            <v-select
              v-model="selectedWebsite"
              :items="websites"
              item-title="name"
              item-value="id"
              label="Select Site"
              outlined
              hide-details
              :disabled="websites.length === 0"
              style="font-size: 14px;"
            ></v-select>
          </v-card-text>
          <v-card-actions style="justify-content: center; margin-top: -16px; margin-bottom: 12px; position: absolute; bottom: 0; width: 100%;">
            <v-btn
              :class="['btn-secondary', activeCard === 'viewSite' ? 'active-button' : '']"
              :disabled="!selectedWebsite"
              @click.stop="applySiteFilter"
              style="padding: 0 40px; height: 36px; font-size: 14px; background-color: #1976d2; color: white;"
            >
              View
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="3">
        <v-card class="elevation-2 hours-calculator-card">
          <v-card-title style="position: relative; display: flex; align-items: center; padding: 8px 16px;">
            <v-icon style="margin-right: 8px; font-size: 28px;">mdi-calculator</v-icon>
            <span style="position: absolute; left: 50%; transform: translateX(-50%); font-size: 16px; font-weight: 600;">Calculator</span>
          </v-card-title>
          <v-card-text class="hours-calculator-body">
            <div class="hours-calculator-inputs">
              <v-text-field
                v-model.number="calculatorHours"
                label="Hours"
                type="number"
                min="0"
                density="compact"
                variant="outlined"
                hide-details
              ></v-text-field>
              <v-text-field
                v-model.number="calculatorMinutes"
                label="Minutes"
                type="number"
                min="0"
                max="59"
                density="compact"
                variant="outlined"
                hide-details
              ></v-text-field>
            </div>
            <div class="hours-calculator-note">Use this number when entering Extra hours.</div>
            <div class="hours-calculator-result">
              <span>Decimal</span>
              <button
                type="button"
                class="hours-calculator-copy"
                title="Copy decimal"
                @click="copyCalculatorDecimal"
              >
                {{ formattedCalculatorDecimal }}
              </button>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="3">
        <v-card
          :class="['elevation-2', activeCard === 'period' ? 'active-card' : '']"
          style="min-height: 180px; border-radius: 6px;"
          @click="setActiveCard('period')"
        >
          <v-card-title style="position: relative; display: flex; align-items: center; padding: 8px 16px;">
            <v-icon style="margin-right: 8px; font-size: 28px;">mdi-calendar-multiple-check</v-icon>
            <span style="position: absolute; left: 50%; transform: translateX(-50%); font-size: 16px; font-weight: 600;">Period</span>
          </v-card-title>
          <v-card-text style="padding: 4px 16px;">
            <v-select
              v-model="selectedPeriod"
              :items="periods"
              item-title="name"
              item-value="id"
              label="Select Period"
              outlined
              hide-details
              :disabled="periods.length === 0"
              style="font-size: 14px;"
            ></v-select>
          </v-card-text>
          <v-card-actions class="hours-period-actions">
            <v-btn
              icon
              class="hours-period-arrow"
              :disabled="!canGoToPreviousPeriod"
              aria-label="Previous period"
              @click.stop="goToPreviousPeriod"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn
              icon
              class="hours-period-arrow"
              :disabled="!canGoToNextPeriod"
              aria-label="Next period"
              @click.stop="goToNextPeriod"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <div v-if="hasActiveFilterChips" class="hours-filter-chip-bar">
      <v-chip
        v-for="model in selectedModelRecords"
        :key="`model-chip-${model.id}`"
        class="hours-filter-chip"
        closable
        color="primary"
        size="small"
        variant="tonal"
        @click:close="removeModelChip(model.id)"
      >
        {{ model.stageName }}
      </v-chip>
      <v-chip
        v-for="site in selectedWebsiteRecords"
        :key="`site-chip-${site.id}`"
        class="hours-filter-chip"
        closable
        color="primary"
        size="small"
        variant="tonal"
        @click:close="removeWebsiteChip(site.id)"
      >
        {{ site.name }}
      </v-chip>
    </div>

    <div class="hours-section-title">
      <div class="hours-title-with-help">
        <h2>Hours</h2>
        <v-menu location="bottom" open-on-hover>
          <template #activator="{ props }">
            <v-icon
              v-bind="props"
              class="hours-help-icon"
              size="18"
            >
              mdi-information-outline
            </v-icon>
          </template>
          <v-card class="hours-help-tooltip-card">
            <div class="hours-help-tooltip-title">Decimal Hours</div>
            <div>Hours are shown as decimals, not minutes.</div>
            <div><strong>4.5</strong> = 4 hours 30 minutes</div>
            <div><strong>4.7</strong> = 4 hours 42 minutes</div>
            <div><strong>6.9</strong> = 6 hours 54 minutes</div>
          </v-card>
        </v-menu>
      </div>
      <div class="hours-save-status">
        <span>
          {{
            savingHours
              ? 'Saving...'
              : unsavedCount > 0
                ? `${unsavedCount} unsaved`
                : `${displayedModels.length} models`
          }}
        </span>
      </div>
    </div>

    <v-card
      v-for="model in displayedModels"
      :key="model.id"
      class="elevation-3 hours-model-card"
    >
      <div class="hours-model-header">
        <span class="hours-model-name">{{ model.fullName }}</span>
        <button
          type="button"
          class="hours-stage-name"
          :title="`Open ${model.stageName || model.fullName} profile`"
          @click="openModelProfile(model)"
        >
          {{ model.stageName }}
        </button>
        <span class="hours-period">{{ selectedPeriodRecord?.name || 'Select Period' }}</span>

        <div class="hours-progress">
          <span>Period Progress</span>
          <div class="hours-progress-track">
            <v-progress-linear
              :model-value="getModelProgress(model).percent"
              :color="getModelProgress(model).color"
              height="5"
              rounded
            ></v-progress-linear>
            <span
              v-for="marker in getModelProgress(model).markers"
              :key="marker.label"
              class="hours-progress-marker-wrap"
              :style="{ left: `${marker.position}%` }"
              :title="marker.label"
            >
              <span class="hours-progress-marker-label">{{ marker.label }}</span>
              <span class="hours-progress-marker"></span>
            </span>
          </div>
        </div>

      </div>

      <div class="hours-table-wrapper">
        <v-table density="compact" class="hours-table">
          <thead>
            <tr>
              <th class="hours-metric-cell">Date</th>
              <th v-for="day in hourDays" :key="day.iso" class="hours-day-cell">
                <span>{{ day.label }}</span>
                <small>{{ day.day }}</small>
              </th>
              <th class="hours-total-cell">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="hours-metric-cell">Report Hours</td>
              <td v-for="(hours, index) in getReportHours(model.id)" :key="`report-${model.id}-${index}`" class="hours-value-cell hours-report-cell">
                <span class="hours-report-value">{{ formatHoursDuration(hours) }}</span>
              </td>
              <td class="hours-total-cell hours-total-report">{{ formatHoursDuration(getReportHoursTotal(model.id)) }}</td>
            </tr>
            <tr
              v-for="site in getVisibleSiteRows(model)"
              :key="`site-row-${model.id}-${site.rowKey}`"
            >
              <td class="hours-metric-cell">
                {{ getSiteRowShortName(site) }}
                <span v-if="isPaySource(model.id, site.id)" class="hours-pay-source-badge">Pay</span>
              </td>
              <td
                v-for="(day, index) in hourDays"
                :key="`site-${model.id}-${site.rowKey}-${day.iso}`"
                class="hours-value-cell"
                :class="getCommentCellClass(model.id, 'site', site.id, day.iso)"
                :data-comment="getCellComment(model.id, 'site', site.id, day.iso)"
                @click.capture="openCommentCell($event, {
                  model,
                  rowType: 'site',
                  rowId: site.id,
                  rowLabel: getSiteRowLabel(site),
                  date: day.iso
                })"
              >
                <v-text-field
                  v-if="isSiteRowActiveOnDay(site, day.iso)"
                  v-model="siteHoursByModel[model.id][site.rowKey][index]"
                  :class="{ 'hours-entry-dirty': isHourDirty(model.id, site.rowKey, day.iso) }"
                  variant="outlined"
                  density="compact"
                  hide-details
                  type="text"
                  :placeholder="getSiteInputPlaceholder(site)"
                  class="hours-entry"
                  @blur="normalizeSiteHourInput(model.id, site.rowKey, index)"
                ></v-text-field>
                <span v-else class="hours-empty-cell"></span>
              </td>
              <td
                class="hours-total-cell"
                :class="getHoursStatusClass(getSiteHoursTotal(model.id, site.rowKey), site.id)"
              >
                <v-text-field
                  v-model="siteTotalHoursByModel[model.id][site.rowKey]"
                  :class="{ 'hours-entry-dirty': isSiteTotalDirty(model.id, site.rowKey) }"
                  variant="outlined"
                  density="compact"
                  hide-details
                  type="text"
                  :placeholder="formatHoursDuration(getSiteAutoHoursTotal(model.id, site.rowKey))"
                  class="hours-entry hours-total-entry"
                  @blur="normalizeSiteTotalInput(model.id, site.rowKey)"
                ></v-text-field>
              </td>
            </tr>
            <tr v-if="shouldShowExtraRow(model)" class="hours-extra-row">
              <td class="hours-metric-cell">Extra</td>
              <td
                v-for="(day, index) in hourDays"
                :key="`extra-${model.id}-${day.iso}`"
                class="hours-value-cell"
                :class="getCommentCellClass(model.id, 'extra', 'extra', day.iso)"
                :data-comment="getCellComment(model.id, 'extra', 'extra', day.iso)"
                @click.capture="openCommentCell($event, {
                  model,
                  rowType: 'extra',
                  rowId: 'extra',
                  rowLabel: 'Extra',
                  date: day.iso
                })"
              >
                <v-text-field
                  v-model="extraHoursByModel[model.id][index]"
                  :class="{ 'hours-entry-dirty': isExtraHourDirty(model.id, day.iso) }"
                  variant="outlined"
                  density="compact"
                  hide-details
                  type="text"
                  placeholder="HH:MM"
                  class="hours-entry"
                ></v-text-field>
              </td>
              <td class="hours-total-cell hours-total-extra">
                <v-text-field
                  v-model="extraTotalHoursByModel[model.id]"
                  :class="{ 'hours-entry-dirty': isExtraTotalDirty(model.id) }"
                  variant="outlined"
                  density="compact"
                  hide-details
                  type="text"
                  :placeholder="formatHoursDuration(getExtraAutoHoursTotal(model.id))"
                  class="hours-entry hours-total-entry"
                ></v-text-field>
              </td>
            </tr>
            <tr class="hours-paid-row">
              <td class="hours-metric-cell">Hours Paid</td>
              <td
                v-for="(hours, index) in getPaidHours(model.id)"
                :key="`paid-${model.id}-${index}`"
                class="hours-value-cell hours-paid-cell"
                :class="getCommentCellClass(model.id, 'paid', 'paid', hourDays[index]?.iso)"
                :data-comment="getCellComment(model.id, 'paid', 'paid', hourDays[index]?.iso)"
                @click.capture="openCommentCell($event, {
                  model,
                  rowType: 'paid',
                  rowId: 'paid',
                  rowLabel: 'Hours Paid',
                  date: hourDays[index]?.iso
                })"
              >
                <span class="hours-paid-value">{{ formatHoursDuration(hours) }}</span>
              </td>
              <td class="hours-total-cell hours-total-paid">
                {{ formatHoursDuration(getPaidHoursTotal(model.id)) }}
              </td>
            </tr>
          </tbody>
        </v-table>
      </div>

      <v-expand-transition>
        <div v-if="isDiffOpen(model.id)" class="hours-diff-panel">
          <div class="hours-diff-toolbar">
            <div class="hours-diff-title">
              <span>Diff</span>
              <small>Selected - Report</small>
            </div>
            <v-select
              :model-value="getDiffSelection(model)"
              :items="getDiffOptions(model)"
              item-title="label"
              item-value="value"
              density="compact"
              variant="outlined"
              hide-details
              class="hours-diff-select"
              @update:model-value="setDiffSelection(model.id, $event)"
            ></v-select>
            <div
              class="hours-diff-total"
              :class="getDiffValueClass(getDiffTotal(model))"
            >
              Total {{ formatSignedHours(getDiffTotal(model)) }}
            </div>
          </div>
          <div class="hours-table-wrapper hours-diff-table-wrapper">
            <v-table density="compact" class="hours-table hours-diff-table">
              <tbody>
                <tr>
                  <td class="hours-metric-cell">Diff</td>
                  <td
                    v-for="(value, index) in getDiffHours(model)"
                    :key="`diff-${model.id}-${hourDays[index]?.iso}`"
                    class="hours-value-cell hours-diff-cell"
                    :class="getDiffValueClass(value)"
                  >
                    {{ formatSignedHours(value) }}
                  </td>
                  <td
                    class="hours-total-cell hours-diff-total-cell"
                    :class="getDiffValueClass(getDiffTotal(model))"
                  >
                    {{ formatSignedHours(getDiffTotal(model)) }}
                  </td>
                </tr>
              </tbody>
            </v-table>
          </div>
        </div>
      </v-expand-transition>

      <div class="hours-card-tools">
        <v-btn
          size="small"
          variant="text"
          class="hours-card-tool-btn"
          prepend-icon="mdi-tune-variant"
          @click="openManageSites(model)"
        >
          Manage Sites
        </v-btn>
        <v-btn
          size="small"
          variant="text"
          class="hours-card-tool-btn"
          :class="{ 'hours-card-tool-btn-active': getModelPeriodNote(model.id) }"
          prepend-icon="mdi-note-text-outline"
          @click="openAddNote(model)"
        >
          Note
        </v-btn>
        <v-btn
          size="small"
          variant="text"
          class="hours-card-tool-btn"
          :class="{ 'hours-card-tool-btn-active': isCommentModeActive(model.id) }"
          prepend-icon="mdi-comment-text-outline"
          @click="toggleCommentMode(model.id)"
        >
          Comment
        </v-btn>
        <v-btn
          size="small"
          variant="text"
          class="hours-card-tool-btn"
          :class="{ 'hours-card-tool-btn-active': isDiffOpen(model.id) }"
          prepend-icon="mdi-compare-horizontal"
          @click="toggleDiff(model)"
        >
          Diff
        </v-btn>
      </div>
    </v-card>

    <v-dialog v-model="manageSitesDialog" max-width="620px">
      <v-card class="hours-dialog">
        <v-card-title class="hours-dialog-title">
          Manage Sites
          <span v-if="manageSitesModel" class="hours-dialog-model">{{ manageSitesModel.stageName }}</span>
        </v-card-title>
        <v-card-text>
          <v-table v-if="manageSitesModel" density="compact" class="hours-manage-sites-table">
            <thead>
              <tr>
                <th>Site</th>
                <th>Show This Period</th>
                <th>Show Every Period</th>
                <th>Pay Source</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="site in websites"
                :key="`manage-${site.id}`"
                :class="{ 'hours-manage-pay-source-row': isPaySource(manageSitesModel.id, site.id) }"
              >
                <td>{{ site.name }}</td>
                <td>
                  <v-checkbox
                    v-model="siteSelectionsByModel[manageSitesModel.id][site.id].show"
                    :disabled="isPaySource(manageSitesModel.id, site.id)"
                    hide-details
                    density="compact"
                  ></v-checkbox>
                </td>
                <td>
                  <v-checkbox
                    v-model="siteSelectionsByModel[manageSitesModel.id][site.id].default"
                    hide-details
                    density="compact"
                  ></v-checkbox>
                </td>
                <td>
                  <v-checkbox
                    :model-value="siteSelectionsByModel[manageSitesModel.id][site.id].paySource"
                    hide-details
                    density="compact"
                    @update:model-value="setPaySource(manageSitesModel.id, site.id, $event)"
                  ></v-checkbox>
                </td>
              </tr>
              <tr class="hours-manage-extra-row">
                <td>Extra</td>
                <td>
                  <v-checkbox
                    v-model="extraSelectionsByModel[manageSitesModel.id].show"
                    hide-details
                    density="compact"
                  ></v-checkbox>
                </td>
                <td>
                  <v-checkbox
                    v-model="extraSelectionsByModel[manageSitesModel.id].default"
                    hide-details
                    density="compact"
                  ></v-checkbox>
                </td>
                <td class="hours-manage-not-applicable">-</td>
              </tr>
            </tbody>
          </v-table>
          <div class="hours-manage-sites-note">
            Pay Source is the site used as the base for Total before Extra. Only one site can be selected.
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn variant="text" @click="manageSitesDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="noteDialog" max-width="520px">
      <v-card class="hours-dialog">
        <v-card-title class="hours-dialog-title">
          Note
          <span v-if="noteModel" class="hours-dialog-model">{{ noteModel.stageName }}</span>
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="draftNote"
            label="Note"
            rows="3"
            variant="outlined"
            hide-details
          ></v-textarea>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            v-if="noteModel && getModelPeriodNote(noteModel.id)"
            color="error"
            variant="text"
            :disabled="savingNote"
            @click="deleteModelNote"
          >
            Delete
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="noteDialog = false">Close</v-btn>
          <v-btn
            color="primary"
            variant="flat"
            :loading="savingNote"
            @click="saveModelNote"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="commentDialog" max-width="520px">
      <v-card class="hours-dialog">
        <v-card-title class="hours-dialog-title">
          Cell Comment
          <span v-if="activeCommentCell" class="hours-dialog-model">
            {{ activeCommentCell.model.stageName }} · {{ activeCommentCell.rowLabel }} · {{ formatCommentDate(activeCommentCell.date) }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="commentDraft"
            label="Comment"
            rows="3"
            variant="outlined"
            hide-details
            autofocus
          ></v-textarea>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            v-if="activeCommentCell && hasCommentForCell(activeCommentCell.model.id, activeCommentCell.rowType, activeCommentCell.rowId, activeCommentCell.date)"
            color="error"
            variant="text"
            :disabled="savingComment"
            @click="deleteCellComment"
          >
            Delete
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn variant="text" :disabled="savingComment" @click="commentDialog = false">Cancel</v-btn>
          <v-btn color="primary" variant="flat" :loading="savingComment" @click="saveCellComment">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import secureAxios from '@/utils/secureAxios';
import { toast } from 'vue3-toastify';
import { debounce } from 'lodash';

export default {
  data() {
    const user = JSON.parse(localStorage.getItem('user')) || {};

    return {
      activeCard: null,
      activeTab: user.role === 'satellite_monitor' ? 'satellite' : null,
      activeCommentCell: null,
      calculatorHours: 0,
      calculatorMinutes: 0,
      cellComments: {},
      commentDialog: false,
      commentDraft: '',
      commentModeModelId: null,
      diffOpenByModel: {},
      diffSelectionByModel: {},
      editablePayStructureRows: [],
      isHoursDashboardCollapsed: false,
      isEditingPayStructure: false,
      payStructureCbDays: 14,
      savingPayStructure: false,
      thresholdRows: [
        { percentage: 45, mainDailyHours: 0, mainHours: 0, mainLabel: '0', mainPercent: 45, cbDailyHours: 0, cbHours: 0, cbLabel: '0', cbPercent: 45 },
        { percentage: 50, mainDailyHours: 6, mainHours: 72, mainLabel: '72', mainPercent: 50, cbDailyHours: 6, cbHours: 72, cbLabel: '72', cbPercent: 50 },
        { percentage: 55, mainDailyHours: 7, mainHours: 84, mainLabel: '84', mainPercent: 55, cbDailyHours: 7, cbHours: 84, cbLabel: '84', cbPercent: 55 },
        { percentage: 60, mainDailyHours: 8, mainHours: 96, mainLabel: '96', mainPercent: 60, cbDailyHours: 8, cbHours: 96, cbLabel: '96', cbPercent: 60 },
      ],
      modelFilter: null,
      models: [],
      manageSitesDialog: false,
      manageSitesModel: null,
      modelPeriodNotes: {},
      noteDialog: false,
      noteModel: null,
      originalSiteHoursByModel: {},
      siteTotalHoursByModel: {},
      originalSiteTotalHoursByModel: {},
      extraHoursByModel: {},
      extraTotalHoursByModel: {},
      extraSelectionsByModel: {},
      originalExtraHoursByModel: {},
      originalExtraTotalHoursByModel: {},
      originalExtraSelectionsByModel: {},
      originalSiteSelectionsByModel: {},
      periods: [],
      reportHoursByModel: {},
      savingComment: false,
      savingHours: false,
      savingNote: false,
      selectedPeriod: null,
      selectedModelIds: [],
      selectedWebsite: null,
      selectedWebsiteIds: [],
      siteHoursByModel: {},
      siteSelectionsByModel: {},
      draftNote: '',
      user,
      websites: [],
    };
  },
  computed: {
    hourDays() {
      const range = this.selectedPeriodDateRange;
      if (!range?.start_date || !range?.end_date) return [];

      const days = [];
      const current = new Date(`${range.start_date}T00:00:00`);
      const end = new Date(`${range.end_date}T00:00:00`);

      while (current <= end) {
        days.push({
          iso: current.toISOString().slice(0, 10),
          label: String(current.getDate()).padStart(2, '0'),
          day: current.toLocaleDateString('en-US', { weekday: 'short' })
        });
        current.setDate(current.getDate() + 1);
      }

      return days;
    },
    isSatelliteMonitor() {
      return this.user?.role === 'satellite_monitor';
    },
    displayedModels() {
      if (this.selectedModelIds.length > 0) return this.selectedModelRecords;
      if (this.selectedWebsiteIds.length > 0) {
        return this.models.filter(model => (
          this.selectedWebsiteIds.some(siteId => this.modelHasVisibleSite(model, siteId))
        ));
      }
      return this.models;
    },
    hasActiveFilterChips() {
      return this.selectedModelIds.length > 0 || this.selectedWebsiteIds.length > 0;
    },
    calculatorDecimal() {
      const hours = Math.max(0, Number(this.calculatorHours || 0));
      const minutes = Math.min(59, Math.max(0, Number(this.calculatorMinutes || 0)));
      return hours + (minutes / 60);
    },
    formattedCalculatorDecimal() {
      return this.calculatorDecimal.toFixed(2).replace(/\.00$/, '').replace(/(\.\d)0$/, '$1');
    },
    dashboardChaturbateDays() {
      return this.getChaturbateDaysFromSelectedPeriod() || this.payStructureCbDays || 14;
    },
    mainPeriodDays() {
      return 14;
    },
    mainPayableDays() {
      return this.getPayableDays(this.mainPeriodDays);
    },
    chaturbatePayableDays() {
      return this.getPayableDays(this.dashboardChaturbateDays);
    },
    hasChaturbatePeriod() {
      return (this.selectedPeriodRecord?.ranges || [])
        .some(range => Number(range.website_id) === 5);
    },
    nextChaturbatePeriodName() {
      if (this.hasChaturbatePeriod || this.selectedPeriodIndex < 0) return '';
      const nextPeriod = this.periods
        .slice(this.selectedPeriodIndex + 1)
        .find(period => (period.ranges || []).some(range => Number(range.website_id) === 5));
      return nextPeriod?.name || '';
    },
    displayedPayStructureRows() {
      return this.isEditingPayStructure ? this.editablePayStructureRows : this.thresholdRows;
    },
    unsavedCount() {
      return this.getDirtyHourEntries().length + this.getDirtyVisibilityEntries().length;
    },
    selectedPeriodRecord() {
      return this.periods.find(period => period.id === this.selectedPeriod) || null;
    },
    selectedPeriodIndex() {
      return this.periods.findIndex(period => period.id === this.selectedPeriod);
    },
    canGoToPreviousPeriod() {
      return this.selectedPeriodIndex > 0;
    },
    canGoToNextPeriod() {
      return this.selectedPeriodIndex !== -1 && this.selectedPeriodIndex < this.periods.length - 1;
    },
    selectedModelRecords() {
      return this.selectedModelIds
        .map(id => this.models.find(model => model.id === id))
        .filter(Boolean);
    },
    selectedWebsiteRecords() {
      return this.selectedWebsiteIds
        .map(id => this.websites.find(site => site.id === id))
        .filter(Boolean);
    },
    selectedPeriodDateRange() {
      const period = this.selectedPeriodRecord;
      const ranges = period?.ranges || [];
      if (ranges.length === 0) return null;

      const startDates = ranges
        .map(range => range.start_date)
        .filter(Boolean)
        .sort();
      const endDates = ranges
        .map(range => range.end_date)
        .filter(Boolean)
        .sort();

      return {
        start_date: startDates[0],
        end_date: endDates[endDates.length - 1]
      };
    },
  },
  watch: {
    activeTab() {
      this.fetchModels();
    },
    unsavedCount(newCount) {
      if (newCount > 0) {
        this.scheduleHoursAutosave();
      }
    },
    calculatorHours(value) {
      const nextValue = Math.max(0, Number(value || 0));
      if (nextValue !== value) this.calculatorHours = nextValue;
    },
    calculatorMinutes(value) {
      const nextValue = Math.min(59, Math.max(0, Number(value || 0)));
      if (nextValue !== value) this.calculatorMinutes = nextValue;
    },
    hourDays: {
      handler(days) {
        this.resetModelHourRows(days);
        this.fetchSavedHours();
        this.fetchReportHours();
        this.fetchHourNotes();
        this.fetchHourComments();
      },
      immediate: false
    },
    selectedPeriod() {
      this.fetchSavedHours();
      this.fetchReportHours();
      this.fetchHourNotes();
      this.fetchHourComments();
      this.fetchPayStructure();
    },
  },
  mounted() {
    this.scheduleHoursAutosave = debounce(() => {
      if (this.unsavedCount > 0 && !this.savingHours && this.selectedPeriod) {
        this.saveHours(true);
      }
    }, 1800);
    this.fetchInitialData();
  },
  beforeUnmount() {
    this.scheduleHoursAutosave?.cancel?.();
    if (this.unsavedCount > 0 && !this.savingHours && this.selectedPeriod) {
      this.saveHours(true);
    }
  },
  methods: {
    async fetchInitialData() {
      await Promise.all([
        this.fetchPeriods(),
        this.fetchWebsites(),
        this.fetchModels()
      ]);
      await this.fetchPayStructure();
      this.resetModelHourRows(this.hourDays);
      await Promise.all([
        this.fetchSavedHours(),
        this.fetchReportHours(),
        this.fetchHourNotes(),
        this.fetchHourComments()
      ]);
    },
    async copyCalculatorDecimal() {
      const value = this.formattedCalculatorDecimal;
      try {
        if (navigator?.clipboard?.writeText) {
          await navigator.clipboard.writeText(value);
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = value;
          textarea.setAttribute('readonly', '');
          textarea.style.position = 'fixed';
          textarea.style.opacity = '0';
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand('copy');
          document.body.removeChild(textarea);
        }
        toast.success(`Copied ${value}`);
      } catch (error) {
        console.error('Error copying decimal hours:', error?.message || error);
        toast.error('Could not copy decimal');
      }
    },
    async fetchModels() {
      try {
        const response = await secureAxios.get('/api/hours/models', {
          params: { tab: this.activeTab, status: 'Active' }
        });
        const models = (response.data || []).map(model => ({
          ...model,
          label: `${model.fullName} (${model.stageName})`
        }));
        this.models = await this.hydrateModelDefaults(models);
        this.selectedModelIds = this.selectedModelIds.filter(id => this.models.some(model => model.id === id));
        this.initializeSiteSelections(true);
        this.resetModelHourRows(this.hourDays);
        if (!this.models.some(model => model.id === this.modelFilter)) {
          this.modelFilter = this.models[0]?.id || null;
        }
        await Promise.all([
          this.fetchSavedHours(),
          this.fetchReportHours(),
          this.fetchHourNotes(),
          this.fetchHourComments()
        ]);
      } catch (error) {
        console.error('Error fetching hours models:', error?.message || error);
      }
    },
    async fetchPeriods() {
      try {
        const response = await secureAxios.get('/api/hours/periods');
        this.periods = response.data || [];
        if (!this.selectedPeriod && this.periods.length > 0) {
          this.selectedPeriod = this.getDefaultPeriodId();
        }
        await this.fetchPayStructure();
      } catch (error) {
        console.error('Error fetching hours periods:', error?.message || error);
      }
    },
    async fetchPayStructure() {
      try {
        const response = await secureAxios.get('/api/hours/pay-structure', {
          params: { periodId: this.selectedPeriod }
        });
        const cbDays = this.getChaturbateDaysFromSelectedPeriod() || Number(response.data?.cbDays || 14);
        this.payStructureCbDays = cbDays;
        this.thresholdRows = (response.data?.rows || []).map(row => ({
          percentage: Number(row.percentage || 0),
          mainDailyHours: Number(row.mainDailyHours ?? row.mainHours ?? 0),
          mainHours: Number(row.mainHours || 0),
          mainLabel: this.formatHoursTotal(row.mainHours),
          mainPercent: Number(row.percentage || 0),
          cbDailyHours: Number(row.cbDailyHours ?? row.cbHoursPerDay ?? row.cbHours ?? 0),
          cbHours: Number(row.cbHours || 0),
          cbLabel: this.formatHoursTotal(row.cbHours),
          cbPercent: Number(row.percentage || 0),
          cbHoursPerDay: Number(row.cbDailyHours ?? row.cbHoursPerDay ?? 0),
          cbUsesDays: Boolean(row.cbUsesDays),
          position: Number(row.position || 0)
        }));
      } catch (error) {
        console.error('Error fetching pay structure:', error?.message || error);
      }
    },
    startEditingPayStructure() {
      this.editablePayStructureRows = this.thresholdRows.map(row => ({
        percentage: Number(row.percentage || row.mainPercent || 0),
        mainDailyHours: Number(row.mainDailyHours ?? 0),
        cbDailyHours: Number(row.cbDailyHours ?? row.cbHoursPerDay ?? 0)
      }));
      this.isEditingPayStructure = true;
    },
    cancelEditingPayStructure() {
      this.editablePayStructureRows = [];
      this.isEditingPayStructure = false;
    },
    async savePayStructure() {
      this.savingPayStructure = true;
      try {
        await secureAxios.post('/api/hours/pay-structure', {
          periodId: this.selectedPeriod,
          cbDays: this.dashboardChaturbateDays,
          mainDays: this.mainPeriodDays,
          rows: this.editablePayStructureRows
        });
        this.isEditingPayStructure = false;
        this.editablePayStructureRows = [];
        await this.fetchPayStructure();
        toast.success('Hours pay structure saved');
      } catch (error) {
        console.error('Error saving pay structure:', error?.message || error);
        toast.error('Failed to save pay structure');
      } finally {
        this.savingPayStructure = false;
      }
    },
    async fetchWebsites() {
      try {
        const response = await secureAxios.get('/api/hours/websites');
        this.websites = response.data || [];
        if (!this.selectedWebsite && this.websites.length > 0) {
          this.selectedWebsite = this.websites[0].id;
        }
        this.initializeSiteSelections();
      } catch (error) {
        console.error('Error fetching websites:', error?.message || error);
      }
    },
    async fetchSavedHours() {
      if (!this.selectedPeriod || this.models.length === 0 || this.websites.length === 0 || this.hourDays.length === 0) return;

      try {
        const response = await secureAxios.get('/api/hours/site-hours', {
          params: { periodId: this.selectedPeriod }
        });
        const nextSiteHours = this.createEmptySiteHourRows(this.hourDays);
        const nextOriginalHours = this.createEmptySiteHourRows(this.hourDays);
        const nextSiteTotals = this.createEmptySiteTotalRows();
        const nextOriginalSiteTotals = this.createEmptySiteTotalRows();
        const nextExtraHours = this.createEmptyExtraHourRows(this.hourDays);
        const nextOriginalExtraHours = this.createEmptyExtraHourRows(this.hourDays);
        const nextExtraTotals = this.createEmptyExtraTotalRows();
        const nextOriginalExtraTotals = this.createEmptyExtraTotalRows();
        const nextSelections = { ...this.siteSelectionsByModel };
        const nextExtraSelections = { ...this.extraSelectionsByModel };

        (response.data || []).forEach(row => {
          const modelId = Number(row.model_id);
          const hourType = row.hour_type || 'site';
          if (hourType === 'total_override') {
            const hours = Number(row.hours || 0);
            const siteId = row.website_id === null || row.website_id === undefined ? null : Number(row.website_id);
            const site = this.getSiteById(siteId);
            const rowKey = site ? this.getSiteRowKey(site, row.hour_label || this.getDefaultSiteHourLabel(site)) : null;
            if (siteId && rowKey && nextSiteTotals[modelId]?.[rowKey] !== undefined) {
              const value = this.formatHoursDuration(hours);
              nextSiteTotals[modelId][rowKey] = value;
              nextOriginalSiteTotals[modelId][rowKey] = value;
              return;
            }

            if (!siteId && nextExtraTotals[modelId] !== undefined) {
              const value = this.formatHoursDuration(hours);
              nextExtraTotals[modelId] = value;
              nextOriginalExtraTotals[modelId] = value;
              if (!nextExtraSelections[modelId]) nextExtraSelections[modelId] = this.buildDefaultExtraSelection();
              nextExtraSelections[modelId].show = true;
              return;
            }
          }

          const dayIndex = this.hourDays.findIndex(day => day.iso === row.work_date);
          if (dayIndex === -1) return;

          if (hourType === 'extra') {
            if (!nextExtraHours[modelId]) return;
            const hours = Number(row.hours || 0) ? this.formatHoursDuration(row.hours) : '';
            nextExtraHours[modelId][dayIndex] = hours;
            nextOriginalExtraHours[modelId][dayIndex] = hours;
            if (!nextExtraSelections[modelId]) nextExtraSelections[modelId] = this.buildDefaultExtraSelection();
            nextExtraSelections[modelId].show = true;
            nextExtraSelections[modelId].default = Boolean(row.default_for_future);
            return;
          }

          const siteId = Number(row.website_id);
          const site = this.getSiteById(siteId);
          const rowKey = site ? this.getSiteRowKey(site, row.hour_label || this.getDefaultSiteHourLabel(site)) : null;
          if (dayIndex === -1 || !rowKey || !nextSiteHours[modelId]?.[rowKey]) return;

          const hours = Number(row.hours || 0) ? this.formatHoursDuration(row.hours) : '';
          nextSiteHours[modelId][rowKey][dayIndex] = hours;
          nextOriginalHours[modelId][rowKey][dayIndex] = hours;

          if (!nextSelections[modelId]) nextSelections[modelId] = this.buildDefaultSiteSelections({ id: modelId });
          if (!nextSelections[modelId][siteId]) {
            nextSelections[modelId][siteId] = {
              show: true,
              default: Boolean(row.default_for_future),
              paySource: Boolean(row.pay_source)
            };
          }
          nextSelections[modelId][siteId].show = true;
          nextSelections[modelId][siteId].default = Boolean(row.default_for_future);
          nextSelections[modelId][siteId].paySource = Boolean(row.pay_source);
        });

        this.siteHoursByModel = nextSiteHours;
        this.originalSiteHoursByModel = nextOriginalHours;
        this.siteTotalHoursByModel = nextSiteTotals;
        this.originalSiteTotalHoursByModel = nextOriginalSiteTotals;
        this.extraHoursByModel = nextExtraHours;
        this.originalExtraHoursByModel = nextOriginalExtraHours;
        this.extraTotalHoursByModel = nextExtraTotals;
        this.originalExtraTotalHoursByModel = nextOriginalExtraTotals;
        this.siteSelectionsByModel = nextSelections;
        this.extraSelectionsByModel = nextExtraSelections;
        this.originalSiteSelectionsByModel = this.cloneSelections(nextSelections);
        this.originalExtraSelectionsByModel = this.cloneSelections(nextExtraSelections);
        await this.fetchHourVisibility();
      } catch (error) {
        console.error('Error fetching saved hours:', error?.message || error);
        toast.error('Failed to fetch saved hours');
      }
    },
    async fetchHourVisibility() {
      if (!this.selectedPeriod || this.models.length === 0 || this.websites.length === 0) return;

      try {
        const response = await secureAxios.get('/api/hours/visibility', {
          params: { periodId: this.selectedPeriod }
        });
        const nextSelections = this.cloneSelections(this.siteSelectionsByModel);
        const nextExtraSelections = this.cloneSelections(this.extraSelectionsByModel);

        (response.data || []).forEach(row => {
          const modelId = Number(row.model_id);
          const visibilityType = row.visibility_type || 'site';
          if (visibilityType === 'extra') {
            if (!nextExtraSelections[modelId]) nextExtraSelections[modelId] = this.buildDefaultExtraSelection();
            nextExtraSelections[modelId].show = Boolean(row.show_this_period);
            nextExtraSelections[modelId].default = Boolean(row.default_for_future);
            return;
          }

          const siteId = Number(row.website_id);
          if (!nextSelections[modelId]) nextSelections[modelId] = this.buildDefaultSiteSelections({ id: modelId });
          if (!nextSelections[modelId][siteId]) {
            nextSelections[modelId][siteId] = { show: false, default: false, paySource: false };
          }
          nextSelections[modelId][siteId].show = Boolean(row.show_this_period || row.pay_source);
          nextSelections[modelId][siteId].default = Boolean(row.default_for_future);
          nextSelections[modelId][siteId].paySource = Boolean(row.pay_source);
        });

        this.siteSelectionsByModel = nextSelections;
        this.extraSelectionsByModel = nextExtraSelections;
        this.originalSiteSelectionsByModel = this.cloneSelections(nextSelections);
        this.originalExtraSelectionsByModel = this.cloneSelections(nextExtraSelections);
      } catch (error) {
        console.error('Error fetching hours visibility:', error?.message || error);
        toast.error('Failed to fetch hours visibility');
      }
    },
    async fetchReportHours() {
      if (!this.selectedPeriod || this.models.length === 0 || this.hourDays.length === 0) return;

      try {
        const response = await secureAxios.get('/api/hours/report-hours', {
          params: { periodId: this.selectedPeriod }
        });
        const nextReportHours = {};
        this.models.forEach(model => {
          nextReportHours[model.id] = this.hourDays.map(() => 0);
        });

        (response.data || []).forEach(row => {
          const modelId = Number(row.model_id);
          const dayIndex = this.hourDays.findIndex(day => day.iso === row.report_date);
          if (dayIndex === -1 || !nextReportHours[modelId]) return;
          nextReportHours[modelId][dayIndex] = Number(row.hours || 0);
        });

        this.reportHoursByModel = nextReportHours;
      } catch (error) {
        console.error('Error fetching report hours:', error?.message || error);
        toast.error('Failed to fetch report hours');
      }
    },
    async fetchHourNotes() {
      if (!this.selectedPeriod || this.models.length === 0) return;

      try {
        const response = await secureAxios.get('/api/hours/notes', {
          params: { periodId: this.selectedPeriod }
        });
        const notes = {};
        (response.data || []).forEach(row => {
          notes[Number(row.model_id)] = row.note || '';
        });
        this.modelPeriodNotes = notes;
      } catch (error) {
        console.error('Error fetching hours notes:', error?.message || error);
        toast.error('Failed to fetch notes');
      }
    },
    async fetchHourComments() {
      if (!this.selectedPeriod || this.models.length === 0 || this.hourDays.length === 0) return;

      try {
        const response = await secureAxios.get('/api/hours/comments', {
          params: { periodId: this.selectedPeriod }
        });
        const comments = {};
        (response.data || []).forEach(row => {
          const rowType = row.comment_type;
          const rowId = rowType === 'site' ? Number(row.website_id) : rowType;
          const key = this.getCommentCellKey(Number(row.model_id), rowType, rowId, row.work_date);
          comments[key] = row.comment_text || '';
        });
        this.cellComments = comments;
      } catch (error) {
        console.error('Error fetching hours comments:', error?.message || error);
        toast.error('Failed to fetch comments');
      }
    },
    getDefaultPeriodId() {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const sortedPeriods = [...this.periods].sort((a, b) => new Date(a.payment_date) - new Date(b.payment_date));
      const selected = sortedPeriods.find(period => {
        if (!period.payment_date) return false;
        const cutoff = new Date(`${period.payment_date}T00:00:00`);
        cutoff.setDate(cutoff.getDate() + 1);
        return today < cutoff;
      });

      return selected?.id || sortedPeriods[sortedPeriods.length - 1]?.id || null;
    },
    addModelChip() {
      if (!this.modelFilter || this.selectedModelIds.includes(this.modelFilter)) return;
      this.selectedModelIds = [...this.selectedModelIds, this.modelFilter];
    },
    applySiteFilter() {
      if (!this.selectedWebsite || this.selectedWebsiteIds.includes(this.selectedWebsite)) return;
      this.selectedWebsiteIds = [...this.selectedWebsiteIds, this.selectedWebsite];
    },
    goToPreviousPeriod() {
      if (!this.canGoToPreviousPeriod) return;
      this.selectedPeriod = this.periods[this.selectedPeriodIndex - 1].id;
      this.setActiveCard('period');
    },
    goToNextPeriod() {
      if (!this.canGoToNextPeriod) return;
      this.selectedPeriod = this.periods[this.selectedPeriodIndex + 1].id;
      this.setActiveCard('period');
    },
    getReportHours(modelId) {
      if (!this.reportHoursByModel[modelId]) {
        this.reportHoursByModel[modelId] = this.hourDays.map(() => 0);
      }
      return this.reportHoursByModel[modelId];
    },
    getReportHoursTotal(modelId) {
      return this.getReportHours(modelId).reduce((total, hours) => total + Number(hours || 0), 0);
    },
    getSiteHours(modelId, siteId) {
      if (!this.siteHoursByModel[modelId]) {
        this.siteHoursByModel[modelId] = {};
      }
      if (!this.siteHoursByModel[modelId][siteId]) {
        this.siteHoursByModel[modelId][siteId] = this.hourDays.map(() => '');
      }
      return this.siteHoursByModel[modelId][siteId];
    },
    getSiteTotalOverride(modelId, siteId) {
      if (!this.siteTotalHoursByModel[modelId]) {
        this.siteTotalHoursByModel[modelId] = {};
      }
      if (this.siteTotalHoursByModel[modelId][siteId] === undefined) {
        this.siteTotalHoursByModel[modelId][siteId] = '';
      }
      return this.siteTotalHoursByModel[modelId][siteId];
    },
    getOriginalSiteTotalOverride(modelId, siteId) {
      if (!this.originalSiteTotalHoursByModel[modelId]) {
        this.originalSiteTotalHoursByModel[modelId] = {};
      }
      if (this.originalSiteTotalHoursByModel[modelId][siteId] === undefined) {
        this.originalSiteTotalHoursByModel[modelId][siteId] = '';
      }
      return this.originalSiteTotalHoursByModel[modelId][siteId];
    },
    hasSiteTotalOverride(modelId, siteId) {
      return String(this.getSiteTotalOverride(modelId, siteId) || '').trim() !== '';
    },
    getSiteAutoHoursTotal(modelId, siteId) {
      const site = this.getSiteRowByKey(siteId);
      return this.getSiteHours(modelId, siteId).reduce((total, hours) => total + this.parseHoursInput(hours, site), 0);
    },
    getSiteHoursTotal(modelId, siteId) {
      const site = this.getSiteRowByKey(siteId);
      return this.hasSiteTotalOverride(modelId, siteId)
        ? this.parseHoursInput(this.getSiteTotalOverride(modelId, siteId), site)
        : this.getSiteAutoHoursTotal(modelId, siteId);
    },
    getExtraHours(modelId) {
      if (!this.extraHoursByModel[modelId]) {
        this.extraHoursByModel[modelId] = this.hourDays.map(() => '');
      }
      return this.extraHoursByModel[modelId];
    },
    getOriginalExtraHours(modelId) {
      if (!this.originalExtraHoursByModel[modelId]) {
        this.originalExtraHoursByModel[modelId] = this.hourDays.map(() => 0);
      }
      return this.originalExtraHoursByModel[modelId];
    },
    getExtraTotalOverride(modelId) {
      if (this.extraTotalHoursByModel[modelId] === undefined) {
        this.extraTotalHoursByModel[modelId] = '';
      }
      return this.extraTotalHoursByModel[modelId];
    },
    getOriginalExtraTotalOverride(modelId) {
      if (this.originalExtraTotalHoursByModel[modelId] === undefined) {
        this.originalExtraTotalHoursByModel[modelId] = '';
      }
      return this.originalExtraTotalHoursByModel[modelId];
    },
    hasExtraTotalOverride(modelId) {
      return String(this.getExtraTotalOverride(modelId) || '').trim() !== '';
    },
    getExtraAutoHoursTotal(modelId) {
      return this.getExtraHours(modelId).reduce((total, hours) => total + this.parseHoursInput(hours), 0);
    },
    getExtraHoursTotal(modelId) {
      return this.hasExtraTotalOverride(modelId)
        ? this.parseHoursInput(this.getExtraTotalOverride(modelId))
        : this.getExtraAutoHoursTotal(modelId);
    },
    getPaidHours(modelId) {
      const paySourceSite = this.getPaySourceSite(modelId);
      const siteRows = paySourceSite ? this.getHourRowsForSite(paySourceSite) : [];
      const extraHours = this.shouldShowExtraRow({ id: modelId }) ? this.getExtraHours(modelId) : this.hourDays.map(() => 0);
      return this.hourDays.map((day, index) => (
        siteRows.reduce((total, siteRow) => total + this.parseHoursInput(this.getSiteHours(modelId, siteRow.rowKey)[index], siteRow), 0) +
        this.parseHoursInput(extraHours[index])
      ));
    },
    getPaidHoursTotal(modelId) {
      const paySourceSite = this.getPaySourceSite(modelId);
      const siteTotal = paySourceSite
        ? this.getHourRowsForSite(paySourceSite).reduce((total, siteRow) => total + this.getSiteHoursTotal(modelId, siteRow.rowKey), 0)
        : 0;
      const extraTotal = this.shouldShowExtraRow({ id: modelId }) ? this.getExtraHoursTotal(modelId) : 0;
      return siteTotal + extraTotal;
    },
    getDiffOptions(model) {
      const siteOptions = this.getVisibleSiteRows(model).map(site => ({
        label: `${this.getSiteRowShortName(site) || 'Site'}${this.isPaySource(model.id, site.id) ? ' (Pay Source)' : ''}`,
        value: `site:${site.rowKey}`
      }));

      const options = [...siteOptions];
      if (this.shouldShowExtraRow(model)) {
        options.push({ label: 'Extra', value: 'extra' });
      }
      options.push({ label: 'Hours Paid', value: 'paid' });

      return options;
    },
    getDefaultDiffSelection(model) {
      const paySourceSite = this.getPaySourceSite(model.id);
      if (paySourceSite) return `site:${this.getHourRowsForSite(paySourceSite)[0]?.rowKey}`;
      const firstVisibleSite = this.getVisibleSiteRows(model)[0];
      return firstVisibleSite ? `site:${firstVisibleSite.rowKey}` : 'paid';
    },
    getDiffSelection(model) {
      const current = this.diffSelectionByModel[model.id];
      const options = this.getDiffOptions(model);
      if (current && options.some(option => option.value === current)) return current;
      return this.getDefaultDiffSelection(model);
    },
    setDiffSelection(modelId, value) {
      this.diffSelectionByModel = {
        ...this.diffSelectionByModel,
        [modelId]: value
      };
    },
    isDiffOpen(modelId) {
      return Boolean(this.diffOpenByModel[modelId]);
    },
    toggleDiff(model) {
      const isOpen = this.isDiffOpen(model.id);
      this.diffOpenByModel = {
        ...this.diffOpenByModel,
        [model.id]: !isOpen
      };
      if (!isOpen && !this.diffSelectionByModel[model.id]) {
        this.setDiffSelection(model.id, this.getDefaultDiffSelection(model));
      }
    },
    getDiffSourceHours(model) {
      const selection = this.getDiffSelection(model);
      if (selection === 'extra') return this.getExtraHours(model.id);
      if (selection === 'paid') return this.getPaidHours(model.id);
      if (String(selection).startsWith('site:')) {
        const siteId = String(selection).slice(5);
        return this.getSiteHours(model.id, siteId);
      }
      return this.hourDays.map(() => 0);
    },
    getDiffHours(model) {
      const selectedHours = this.getDiffSourceHours(model);
      const reportHours = this.getReportHours(model.id);
      const selection = this.getDiffSelection(model);
      const site = String(selection).startsWith('site:')
        ? this.getSiteRowByKey(String(selection).slice(5))
        : null;
      return this.hourDays.map((day, index) => (
        this.parseHoursInput(selectedHours[index], site) - Number(reportHours[index] || 0)
      ));
    },
    getDiffTotal(model) {
      const reportTotal = this.getReportHoursTotal(model.id);
      const selection = this.getDiffSelection(model);
      if (selection === 'extra') return this.getExtraHoursTotal(model.id) - reportTotal;
      if (selection === 'paid') return this.getPaidHoursTotal(model.id) - reportTotal;
      if (String(selection).startsWith('site:')) {
        const siteId = String(selection).slice(5);
        return this.getSiteHoursTotal(model.id, siteId) - reportTotal;
      }
      return this.getDiffHours(model).reduce((total, hours) => total + Number(hours || 0), 0);
    },
    getDiffValueClass(value) {
      const numberValue = Number(value || 0);
      return {
        'hours-diff-positive': numberValue > 0,
        'hours-diff-negative': numberValue < 0,
        'hours-diff-zero': numberValue === 0
      };
    },
    formatSignedHours(value) {
      const numberValue = Number(value || 0);
      if (numberValue === 0) return '0';
      const formatted = this.formatHoursDuration(Math.abs(numberValue));
      return `${numberValue > 0 ? '+' : '-'}${formatted}`;
    },
    getThresholdsForSite(siteId) {
      const isChaturbate = Number(siteId) === 5;
      const rowsByPercent = new Map(this.thresholdRows.map(row => [Number(row.percentage), row]));
      const row50 = rowsByPercent.get(50);
      const row55 = rowsByPercent.get(55);
      const row60 = rowsByPercent.get(60);
      if (row50 && row55 && row60) {
        return isChaturbate
          ? { pay50: Number(row50.cbHours || 0), pay55: Number(row55.cbHours || 0), pay60: Number(row60.cbHours || 0) }
          : { pay50: Number(row50.mainHours || 0), pay55: Number(row55.mainHours || 0), pay60: Number(row60.mainHours || 0) };
      }

      return isChaturbate
        ? { pay50: 78, pay55: 91, pay60: 104 }
        : { pay50: 72, pay55: 84, pay60: 96 };
    },
    getHoursProgressColor(total, siteId) {
      const thresholds = this.getThresholdsForSite(siteId);
      if (total >= thresholds.pay50) return '#2e7d32';
      if (total >= thresholds.pay50 * 0.5) return '#d9a900';
      return '#c62828';
    },
    getHoursStatusClass(total, siteId) {
      const thresholds = this.getThresholdsForSite(siteId);
      if (total >= thresholds.pay50) return 'hours-total-good';
      if (total >= thresholds.pay50 * 0.5) return 'hours-total-warning';
      return 'hours-total-low';
    },
    getModelProgress(model) {
      const visibleSites = this.getVisibleSites(model);
      const site = this.getPaySourceSite(model.id) || visibleSites[0];
      const siteId = site?.id || 1;
      const total = this.getPaidHoursTotal(model.id);
      const thresholds = this.getThresholdsForSite(siteId);
      const percent = Math.min(100, Math.round((total / thresholds.pay60) * 100));

      return {
        color: this.getHoursProgressColor(total, siteId),
        percent,
        markers: [
          { label: '50%', position: (thresholds.pay50 / thresholds.pay60) * 100 },
          { label: '55%', position: (thresholds.pay55 / thresholds.pay60) * 100 },
          { label: '60%', position: 100 },
        ]
      };
    },
    formatHoursTotal(value) {
      const total = Number(value || 0);
      return total.toFixed(2).replace(/\.00$/, '').replace(/(\.\d)0$/, '$1');
    },
    formatHoursDuration(value) {
      const total = Math.max(0, Number(value || 0));
      const wholeHours = Math.floor(total);
      const minutes = Math.round((total - wholeHours) * 60);
      if (minutes === 60) return `${wholeHours + 1}:00`;
      return `${wholeHours}:${String(minutes).padStart(2, '0')}`;
    },
    getSiteById(siteId) {
      return this.websites.find(site => Number(site.id) === Number(siteId)) || null;
    },
    getSiteRowKey(site, label = null) {
      const rowLabel = this.normalizeSiteHourLabel(site, label);
      return `${site?.id || 'site'}:${rowLabel}`;
    },
    getDefaultSiteHourLabel(site) {
      return this.isStreamateSite(site) ? 'Streamate 1' : 'Site';
    },
    normalizeSiteHourLabel(site, label = null) {
      const cleanLabel = String(label || '').trim();
      if (cleanLabel === 'Total') return this.getDefaultSiteHourLabel(site);
      if (this.isStreamateSite(site) && (!cleanLabel || cleanLabel === 'Site')) return 'Streamate 1';
      return cleanLabel || this.getDefaultSiteHourLabel(site);
    },
    getSiteRowLabel(siteRow) {
      return siteRow?.hourLabel || this.getDefaultSiteHourLabel(siteRow);
    },
    isStreamateSite(site) {
      return String(site?.name || '').toLowerCase().replace(/\s+/g, '') === 'streamate';
    },
    getHourRowsForSite(site) {
      if (this.isStreamateSite(site)) {
        return [
          { ...site, rowKey: this.getSiteRowKey(site, 'Streamate 1'), hourLabel: 'Streamate 1', rowShortName: 'SM 1' },
          { ...site, rowKey: this.getSiteRowKey(site, 'Streamate 2'), hourLabel: 'Streamate 2', rowShortName: 'SM 2' }
        ];
      }

      return [{ ...site, rowKey: this.getSiteRowKey(site), hourLabel: this.getDefaultSiteHourLabel(site), rowShortName: this.getSiteShortName(site) }];
    },
    getSiteRowByKey(rowKey) {
      const [siteIdRaw, ...labelParts] = String(rowKey || '').split(':');
      const site = this.getSiteById(Number(siteIdRaw));
      if (!site) return null;
      const label = this.normalizeSiteHourLabel(site, labelParts.join(':'));
      return this.getHourRowsForSite(site).find(row => row.hourLabel === label) || { ...site, rowKey, hourLabel: label };
    },
    getSiteInputMode(site) {
      const normalized = String(site?.name || '').toLowerCase().replace(/\s+/g, '');
      if (normalized === 'flirt4free') return 'decimal';
      if (normalized === 'streamate') return 'minutes';
      return 'hhmm';
    },
    getSiteInputPlaceholder(site) {
      const mode = this.getSiteInputMode(site);
      if (mode === 'decimal') return '0.00';
      if (mode === 'minutes') return 'Minutes';
      return 'HH:MM';
    },
    formatHoursInput(value, site = null) {
      const hours = Number(value || 0);
      const mode = this.getSiteInputMode(site);
      if (!hours) return '';
      if (mode === 'decimal') return this.formatHoursTotal(hours);
      if (mode === 'minutes') return String(Math.round(hours * 60));
      return this.formatHoursDuration(hours);
    },
    formatHoursDisplayInput(value, site = null) {
      const hours = this.parseHoursInput(value, site);
      return hours ? this.formatHoursDuration(hours) : '';
    },
    normalizeSiteHourInput(modelId, siteId, index) {
      const site = this.getSiteRowByKey(siteId);
      const value = this.getSiteHours(modelId, siteId)[index];
      this.siteHoursByModel[modelId][siteId][index] = this.formatHoursDisplayInput(value, site);
    },
    normalizeSiteTotalInput(modelId, siteId) {
      const site = this.getSiteRowByKey(siteId);
      const value = this.getSiteTotalOverride(modelId, siteId);
      this.siteTotalHoursByModel[modelId][siteId] = this.formatHoursDisplayInput(value, site);
    },
    parseHoursInput(value, site = null) {
      if (value === null || value === undefined) return 0;
      const raw = String(value).trim().toLowerCase();
      if (!raw) return 0;

      const secondsMatch = raw.match(/^(\d+(?:\.\d+)?)\s*(s|sec|secs|second|seconds)$/);
      if (secondsMatch) return Number((Number(secondsMatch[1]) / 3600).toFixed(2));

      const minutesMatch = raw.match(/^(\d+(?:\.\d+)?)\s*(m|min|mins|minute|minutes)$/);
      if (minutesMatch) return Number((Number(minutesMatch[1]) / 60).toFixed(2));

      const hoursMinutesMatch = raw.match(/^(?:(\d+(?:\.\d+)?)\s*h(?:ours?)?)?\s*(?:(\d+(?:\.\d+)?)\s*m(?:in(?:ute)?s?)?)?$/);
      if (hoursMinutesMatch && (hoursMinutesMatch[1] || hoursMinutesMatch[2])) {
        return Number((Number(hoursMinutesMatch[1] || 0) + (Number(hoursMinutesMatch[2] || 0) / 60)).toFixed(2));
      }

      if (raw.includes(':')) {
        const [hoursRaw, minutesRaw = '0'] = raw.split(':');
        const hours = Number(hoursRaw || 0);
        const minutes = Number(minutesRaw || 0);
        if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return 0;
        return Number((Math.max(0, hours) + (Math.min(59, Math.max(0, minutes)) / 60)).toFixed(2));
      }

      const numeric = Number(raw);
      if (!Number.isFinite(numeric)) return 0;
      return this.getSiteInputMode(site) === 'minutes'
        ? Number((numeric / 60).toFixed(2))
        : numeric;
    },
    getOriginalSiteHours(modelId, siteId) {
      if (!this.originalSiteHoursByModel[modelId]) {
        this.originalSiteHoursByModel[modelId] = {};
      }
      if (!this.originalSiteHoursByModel[modelId][siteId]) {
        this.originalSiteHoursByModel[modelId][siteId] = this.hourDays.map(() => 0);
      }
      return this.originalSiteHoursByModel[modelId][siteId];
    },
    getVisibleSites(model) {
      this.ensureModelSiteSelections(model);
      const selections = this.siteSelectionsByModel[model.id] || {};
      return this.websites
        .filter(site => selections[site.id]?.show)
        .sort((a, b) => {
          const aPay = selections[a.id]?.paySource ? 0 : 1;
          const bPay = selections[b.id]?.paySource ? 0 : 1;
          if (aPay !== bPay) return aPay - bPay;
          return this.websites.findIndex(site => site.id === a.id) - this.websites.findIndex(site => site.id === b.id);
        });
    },
    getVisibleSiteRows(model) {
      return this.getVisibleSites(model).flatMap(site => this.getHourRowsForSite(site));
    },
    async hydrateModelDefaults(models) {
      if (models.length === 0 || models.every(model => Object.prototype.hasOwnProperty.call(model, 'paginaAjuste'))) {
        return models;
      }

      try {
        const response = await secureAxios.get('/api/models', {
          params: { status: 'Active' }
        });
        const defaultsById = new Map((response.data || []).map(model => [model.id, model.paginaAjuste]));
        return models.map(model => ({
          ...model,
          paginaAjuste: model.paginaAjuste ?? defaultsById.get(model.id) ?? ''
        }));
      } catch (error) {
        console.error('Error fetching model defaults:', error?.message || error);
        return models;
      }
    },
    initializeSiteSelections(refreshEmptyDefaults = false) {
      if (this.models.length === 0 || this.websites.length === 0) return;

      const nextSelections = { ...this.siteSelectionsByModel };
      this.models.forEach(model => {
        const hasVisibleSite = nextSelections[model.id]
          ? Object.values(nextSelections[model.id]).some(selection => selection?.show)
          : false;
        if (!nextSelections[model.id] || (refreshEmptyDefaults && !hasVisibleSite)) {
          nextSelections[model.id] = this.buildDefaultSiteSelections(model);
        }
        if (!this.extraSelectionsByModel[model.id]) {
          this.extraSelectionsByModel[model.id] = this.buildDefaultExtraSelection();
        }
      });
      this.siteSelectionsByModel = nextSelections;
    },
    buildDefaultExtraSelection() {
      return { show: false, default: false };
    },
    cloneSelections(selections) {
      return JSON.parse(JSON.stringify(selections || {}));
    },
    buildDefaultSiteSelections(model) {
      const defaultSiteId = this.getModelDefaultSiteId(model);
      const selections = {};

      this.websites.forEach(site => {
        const isDefault = site.id === defaultSiteId;
        selections[site.id] = {
          show: isDefault,
          default: isDefault,
          paySource: isDefault
        };
      });

      return selections;
    },
    modelHasVisibleSite(model, siteId) {
      this.ensureModelSiteSelections(model);
      return !!this.siteSelectionsByModel[model.id]?.[siteId]?.show;
    },
    getSiteRowWeekNumber(siteRow) {
      if (!this.isStreamateSite(siteRow)) return null;
      if (siteRow?.hourLabel === 'Streamate 1') return 1;
      if (siteRow?.hourLabel === 'Streamate 2') return 2;
      return null;
    },
    isSiteRowActiveOnDay(siteRow, isoDate) {
      const ranges = this.selectedPeriodRecord?.ranges || [];
      const rowWeekNumber = this.getSiteRowWeekNumber(siteRow);
      return ranges.some(range => (
        Number(range.website_id) === Number(siteRow.id) &&
        (rowWeekNumber === null || Number(range.week_number) === rowWeekNumber) &&
        isoDate >= range.start_date &&
        isoDate <= range.end_date
      ));
    },
    isSiteActiveOnDay(siteId, isoDate) {
      const ranges = this.selectedPeriodRecord?.ranges || [];
      return ranges.some(range => (
        range.website_id === siteId &&
        isoDate >= range.start_date &&
        isoDate <= range.end_date
      ));
    },
    ensureModelSiteSelections(model) {
      if (!this.siteSelectionsByModel[model.id] && this.websites.length > 0) {
        this.siteSelectionsByModel[model.id] = this.buildDefaultSiteSelections(model);
      }
      if (!this.extraSelectionsByModel[model.id]) {
        this.extraSelectionsByModel[model.id] = this.buildDefaultExtraSelection();
      }
    },
    setPaySource(modelId, siteId, value) {
      if (!this.siteSelectionsByModel[modelId]) return;

      Object.keys(this.siteSelectionsByModel[modelId]).forEach(selectionSiteId => {
        this.siteSelectionsByModel[modelId][selectionSiteId].paySource = false;
      });

      if (value) {
        this.siteSelectionsByModel[modelId][siteId].paySource = true;
        this.siteSelectionsByModel[modelId][siteId].show = true;
      }
    },
    isPaySource(modelId, siteId) {
      return Boolean(this.siteSelectionsByModel[modelId]?.[siteId]?.paySource);
    },
    getPaySourceSite(modelId) {
      return this.websites.find(site => this.isPaySource(modelId, site.id)) || null;
    },
    getSiteShortName(site) {
      const normalized = String(site?.name || '').toLowerCase().replace(/\s+/g, '');
      const labels = {
        flirt4free: 'F4F',
        streamate: 'SM',
        livejasmin: 'LJ',
        chaturbate: 'CB',
        stripchat: 'SC',
        kwiky: 'KWK',
        sinparty: 'SP',
        cams: 'Cams',
        cam4: 'Cam4',
        bonga: 'Bonga'
      };
      return labels[normalized] || site?.name || '';
    },
    getSiteRowShortName(siteRow) {
      return siteRow?.rowShortName || this.getSiteShortName(siteRow);
    },
    shouldShowExtraRow(model) {
      const selection = this.extraSelectionsByModel[model.id];
      return Boolean(selection?.show || this.getExtraHoursTotal(model.id) > 0);
    },
    getModelDefaultSiteId(model) {
      const raw = String(model?.paginaAjuste || '').trim().toLowerCase();
      const normalized = raw.replace(/\s+/g, '').replace('-', '');
      const aliases = {
        flirt4free: 'flirt4free',
        f4f: 'flirt4free',
        streamate: 'streamate',
        sm: 'streamate',
        livejasmin: 'livejasmin',
        lj: 'livejasmin',
        chaturbate: 'chaturbate',
        cb: 'chaturbate',
        stripchat: 'stripchat',
        strip: 'stripchat',
        kwiky: 'kwiky',
        kwk: 'kwiky',
        sinparty: 'sinparty',
        sp: 'sinparty',
        cams: 'cams',
        streamray: 'cams',
        cam4: 'cam4',
        bonga: 'bonga',
      };
      const target = aliases[normalized] || normalized;
      return this.websites.find(site => site.name.toLowerCase().replace(/\s+/g, '') === target)?.id || null;
    },
    openManageSites(model) {
      this.ensureModelSiteSelections(model);
      this.manageSitesModel = model;
      this.manageSitesDialog = true;
    },
    openAddNote(model) {
      this.noteModel = model;
      this.draftNote = this.getModelPeriodNote(model.id);
      this.noteDialog = true;
    },
    getModelPeriodNote(modelId) {
      return this.modelPeriodNotes[modelId] || '';
    },
    async saveModelNote() {
      if (!this.noteModel || !this.selectedPeriod) return;

      this.savingNote = true;
      try {
        const note = String(this.draftNote || '').trim();
        await secureAxios.post('/api/hours/notes', {
          periodId: this.selectedPeriod,
          modelId: this.noteModel.id,
          note
        });

        const nextNotes = { ...this.modelPeriodNotes };
        if (note) {
          nextNotes[this.noteModel.id] = note;
        } else {
          delete nextNotes[this.noteModel.id];
        }
        this.modelPeriodNotes = nextNotes;
        this.noteDialog = false;
        toast.success(note ? 'Note saved' : 'Note removed');
      } catch (error) {
        console.error('Error saving hours note:', error?.message || error);
        toast.error('Failed to save note');
      } finally {
        this.savingNote = false;
      }
    },
    async deleteModelNote() {
      this.draftNote = '';
      await this.saveModelNote();
    },
    toggleCommentMode(modelId) {
      this.commentModeModelId = this.commentModeModelId === modelId ? null : modelId;
    },
    isCommentModeActive(modelId) {
      return this.commentModeModelId === modelId;
    },
    getCommentCellKey(modelId, rowType, rowId, date) {
      return [modelId, rowType, rowId || 'none', date || 'none'].join('|');
    },
    hasCommentForCell(modelId, rowType, rowId, date) {
      const key = this.getCommentCellKey(modelId, rowType, rowId, date);
      return Boolean(String(this.cellComments[key] || '').trim());
    },
    getCellComment(modelId, rowType, rowId, date) {
      const key = this.getCommentCellKey(modelId, rowType, rowId, date);
      return this.cellComments[key] || '';
    },
    getCommentCellClass(modelId, rowType, rowId, date) {
      return {
        'hours-comment-mode-cell': this.isCommentModeActive(modelId),
        'hours-commented-cell': this.hasCommentForCell(modelId, rowType, rowId, date)
      };
    },
    openCommentCell(event, cell) {
      if (!this.isCommentModeActive(cell.model.id)) return;

      event.preventDefault();
      event.stopPropagation();

      if (!cell.date) return;

      const key = this.getCommentCellKey(cell.model.id, cell.rowType, cell.rowId, cell.date);
      this.activeCommentCell = { ...cell, key };
      this.commentDraft = this.cellComments[key] || '';
      this.commentDialog = true;
    },
    async saveCellComment() {
      if (!this.activeCommentCell) return;

      const value = String(this.commentDraft || '').trim();
      this.savingComment = true;
      try {
        await secureAxios.post('/api/hours/comments', {
          periodId: this.selectedPeriod,
          modelId: this.activeCommentCell.model.id,
          websiteId: this.activeCommentCell.rowType === 'site' ? this.activeCommentCell.rowId : null,
          date: this.activeCommentCell.date,
          commentType: this.activeCommentCell.rowType,
          commentText: value
        });

        const nextComments = { ...this.cellComments };
        if (value) {
          nextComments[this.activeCommentCell.key] = value;
        } else {
          delete nextComments[this.activeCommentCell.key];
        }

        this.cellComments = nextComments;
        this.commentDialog = false;
        toast.success(value ? 'Comment saved' : 'Comment removed');
      } catch (error) {
        console.error('Error saving hours comment:', error?.message || error);
        toast.error('Failed to save comment');
      } finally {
        this.savingComment = false;
      }
    },
    async deleteCellComment() {
      if (!this.activeCommentCell) return;
      this.commentDraft = '';
      await this.saveCellComment();
    },
    formatCommentDate(date) {
      if (!date) return '';
      const parsed = new Date(`${date}T00:00:00`);
      if (Number.isNaN(parsed.getTime())) return date;
      return parsed.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    },
    openModelProfile(model) {
      if (!model?.id) return;
      const profileUrl = `${window.location.origin}/model/${model.id}/overview`;
      window.open(profileUrl, '_blank');
    },
    removeModelChip(modelId) {
      this.selectedModelIds = this.selectedModelIds.filter(id => id !== modelId);
    },
    removeWebsiteChip(siteId) {
      this.selectedWebsiteIds = this.selectedWebsiteIds.filter(id => id !== siteId);
    },
    toggleHoursDashboard() {
      this.isHoursDashboardCollapsed = !this.isHoursDashboardCollapsed;
    },
    getDaysOffForPeriodDays(days) {
      return Math.floor(Number(days || 0) / 7);
    },
    getPayableDays(days) {
      return Math.max(0, Number(days || 0) - this.getDaysOffForPeriodDays(days));
    },
    getMainPeriodHours(row) {
      return Number((Number(row?.mainDailyHours || 0) * this.mainPayableDays).toFixed(2));
    },
    getCbPeriodHours(row) {
      return Number((Number(row?.cbDailyHours || 0) * this.chaturbatePayableDays).toFixed(2));
    },
    countDaysInRange(startDate, endDate) {
      if (!startDate || !endDate) return 0;
      const current = new Date(`${startDate}T00:00:00`);
      const end = new Date(`${endDate}T00:00:00`);
      if (Number.isNaN(current.getTime()) || Number.isNaN(end.getTime()) || current > end) return 0;

      let days = 0;
      while (current <= end) {
        days += 1;
        current.setDate(current.getDate() + 1);
      }
      return days;
    },
    getChaturbateDaysFromSelectedPeriod() {
      const ranges = this.selectedPeriodRecord?.ranges || [];
      return ranges
        .filter(range => Number(range.website_id) === 5)
        .reduce((total, range) => total + this.countDaysInRange(range.start_date, range.end_date), 0);
    },
    createEmptySiteHourRows(days) {
      const siteRows = {};
      this.models.forEach(model => {
        siteRows[model.id] = {};
        this.websites.forEach(site => {
          this.getHourRowsForSite(site).forEach(siteRow => {
            siteRows[model.id][siteRow.rowKey] = days.map(() => '');
          });
        });
      });
      return siteRows;
    },
    createEmptySiteTotalRows() {
      const siteRows = {};
      this.models.forEach(model => {
        siteRows[model.id] = {};
        this.websites.forEach(site => {
          this.getHourRowsForSite(site).forEach(siteRow => {
            siteRows[model.id][siteRow.rowKey] = '';
          });
        });
      });
      return siteRows;
    },
    createEmptyExtraHourRows(days) {
      const rows = {};
      this.models.forEach(model => {
        rows[model.id] = days.map(() => '');
      });
      return rows;
    },
    createEmptyExtraTotalRows() {
      const rows = {};
      this.models.forEach(model => {
        rows[model.id] = '';
      });
      return rows;
    },
    getDirtyHourEntries() {
      if (!this.selectedPeriod) return [];

      const entries = [];
      this.models.forEach(model => {
        const visibleSites = this.getVisibleSiteRows(model);
        visibleSites.forEach(site => {
          const currentSelection = this.siteSelectionsByModel[model.id]?.[site.id] || {};
          const originalSelection = this.originalSiteSelectionsByModel[model.id]?.[site.id] || {};
          const selectionChanged = (
            Boolean(currentSelection.default) !== Boolean(originalSelection.default) ||
            Boolean(currentSelection.paySource) !== Boolean(originalSelection.paySource)
          );

          this.hourDays.forEach((day, index) => {
            if (!this.isSiteRowActiveOnDay(site, day.iso)) return;

            const current = this.parseHoursInput(this.getSiteHours(model.id, site.rowKey)[index], site);
            const original = this.parseHoursInput(this.getOriginalSiteHours(model.id, site.rowKey)[index], site);
            if (current !== original || selectionChanged) {
              entries.push({
                modelId: model.id,
                websiteId: site.id,
                date: day.iso,
                hours: current,
                hourLabel: site.hourLabel,
                defaultForFuture: Boolean(this.siteSelectionsByModel[model.id]?.[site.id]?.default),
                paySource: Boolean(this.siteSelectionsByModel[model.id]?.[site.id]?.paySource)
              });
            }
          });

          const currentTotalRaw = String(this.getSiteTotalOverride(model.id, site.rowKey) || '').trim();
          const originalTotalRaw = String(this.getOriginalSiteTotalOverride(model.id, site.rowKey) || '').trim();
          const currentTotal = this.parseHoursInput(currentTotalRaw, site);
          const originalTotal = this.parseHoursInput(originalTotalRaw, site);
          if (currentTotalRaw !== originalTotalRaw || currentTotal !== originalTotal || selectionChanged) {
            entries.push({
              modelId: model.id,
              websiteId: site.id,
              date: this.selectedPeriodDateRange?.end_date || this.hourDays[this.hourDays.length - 1]?.iso,
              hours: currentTotal,
              hourType: 'total_override',
              hourLabel: site.hourLabel,
              deleteEntry: !currentTotalRaw,
              defaultForFuture: Boolean(this.siteSelectionsByModel[model.id]?.[site.id]?.default),
              paySource: Boolean(this.siteSelectionsByModel[model.id]?.[site.id]?.paySource)
            });
          }
        });

        if (this.shouldShowExtraRow(model)) {
          const currentExtraSelection = this.extraSelectionsByModel[model.id] || {};
          const originalExtraSelection = this.originalExtraSelectionsByModel[model.id] || {};
          const extraSelectionChanged = Boolean(currentExtraSelection.default) !== Boolean(originalExtraSelection.default);

          this.hourDays.forEach((day, index) => {
            const current = this.parseHoursInput(this.getExtraHours(model.id)[index]);
            const original = this.parseHoursInput(this.getOriginalExtraHours(model.id)[index]);
            if (current !== original || extraSelectionChanged) {
              entries.push({
                modelId: model.id,
                websiteId: null,
                date: day.iso,
                hours: current,
                hourType: 'extra',
                defaultForFuture: Boolean(this.extraSelectionsByModel[model.id]?.default),
                paySource: false
              });
            }
          });

          const currentExtraTotalRaw = String(this.getExtraTotalOverride(model.id) || '').trim();
          const originalExtraTotalRaw = String(this.getOriginalExtraTotalOverride(model.id) || '').trim();
          const currentExtraTotal = this.parseHoursInput(currentExtraTotalRaw);
          const originalExtraTotal = this.parseHoursInput(originalExtraTotalRaw);
          if (currentExtraTotalRaw !== originalExtraTotalRaw || currentExtraTotal !== originalExtraTotal || extraSelectionChanged) {
            entries.push({
              modelId: model.id,
              websiteId: null,
              date: this.selectedPeriodDateRange?.end_date || this.hourDays[this.hourDays.length - 1]?.iso,
              hours: currentExtraTotal,
              hourType: 'total_override',
              deleteEntry: !currentExtraTotalRaw,
              defaultForFuture: Boolean(this.extraSelectionsByModel[model.id]?.default),
              paySource: false
            });
          }
        }
      });

      return entries;
    },
    getDirtyVisibilityEntries() {
      if (!this.selectedPeriod) return [];

      const entries = [];
      this.models.forEach(model => {
        const currentSiteSelections = this.siteSelectionsByModel[model.id] || {};
        const originalSiteSelections = this.originalSiteSelectionsByModel[model.id] || {};

        this.websites.forEach(site => {
          const current = currentSiteSelections[site.id] || { show: false, default: false, paySource: false };
          const original = originalSiteSelections[site.id] || { show: false, default: false, paySource: false };
          const changed = (
            Boolean(current.show) !== Boolean(original.show) ||
            Boolean(current.default) !== Boolean(original.default) ||
            Boolean(current.paySource) !== Boolean(original.paySource)
          );

          if (changed) {
            entries.push({
              modelId: model.id,
              websiteId: site.id,
              visibilityType: 'site',
              showThisPeriod: Boolean(current.show || current.paySource),
              defaultForFuture: Boolean(current.default),
              paySource: Boolean(current.paySource)
            });
          }
        });

        const currentExtra = this.extraSelectionsByModel[model.id] || { show: false, default: false };
        const originalExtra = this.originalExtraSelectionsByModel[model.id] || { show: false, default: false };
        const extraChanged = (
          Boolean(currentExtra.show) !== Boolean(originalExtra.show) ||
          Boolean(currentExtra.default) !== Boolean(originalExtra.default)
        );

        if (extraChanged) {
          entries.push({
            modelId: model.id,
            websiteId: null,
            visibilityType: 'extra',
            showThisPeriod: Boolean(currentExtra.show),
            defaultForFuture: Boolean(currentExtra.default),
            paySource: false
          });
        }
      });

      return entries;
    },
    isHourDirty(modelId, siteId, isoDate) {
      const index = this.hourDays.findIndex(day => day.iso === isoDate);
      if (index === -1) return false;
      const site = this.getSiteRowByKey(siteId);
      const current = this.parseHoursInput(this.getSiteHours(modelId, siteId)[index], site);
      const original = this.parseHoursInput(this.getOriginalSiteHours(modelId, siteId)[index], site);
      return current !== original;
    },
    isSiteTotalDirty(modelId, siteId) {
      const site = this.getSiteRowByKey(siteId);
      const currentRaw = String(this.getSiteTotalOverride(modelId, siteId) || '').trim();
      const originalRaw = String(this.getOriginalSiteTotalOverride(modelId, siteId) || '').trim();
      return currentRaw !== originalRaw || this.parseHoursInput(currentRaw, site) !== this.parseHoursInput(originalRaw, site);
    },
    isExtraHourDirty(modelId, isoDate) {
      const index = this.hourDays.findIndex(day => day.iso === isoDate);
      if (index === -1) return false;
      const current = this.parseHoursInput(this.getExtraHours(modelId)[index]);
      const original = this.parseHoursInput(this.getOriginalExtraHours(modelId)[index]);
      return current !== original;
    },
    isExtraTotalDirty(modelId) {
      const currentRaw = String(this.getExtraTotalOverride(modelId) || '').trim();
      const originalRaw = String(this.getOriginalExtraTotalOverride(modelId) || '').trim();
      return currentRaw !== originalRaw || this.parseHoursInput(currentRaw) !== this.parseHoursInput(originalRaw);
    },
    resetModelHourRows(days) {
      const reportRows = {};
      const siteRows = this.createEmptySiteHourRows(days);
      const originalSiteRows = this.createEmptySiteHourRows(days);
      const siteTotalRows = this.createEmptySiteTotalRows();
      const originalSiteTotalRows = this.createEmptySiteTotalRows();
      const extraRows = this.createEmptyExtraHourRows(days);
      const originalExtraRows = this.createEmptyExtraHourRows(days);
      const extraTotalRows = this.createEmptyExtraTotalRows();
      const originalExtraTotalRows = this.createEmptyExtraTotalRows();
      this.models.forEach(model => {
        reportRows[model.id] = days.map(() => 0);
      });
      this.reportHoursByModel = reportRows;
      this.siteHoursByModel = siteRows;
      this.originalSiteHoursByModel = originalSiteRows;
      this.siteTotalHoursByModel = siteTotalRows;
      this.originalSiteTotalHoursByModel = originalSiteTotalRows;
      this.extraHoursByModel = extraRows;
      this.originalExtraHoursByModel = originalExtraRows;
      this.extraTotalHoursByModel = extraTotalRows;
      this.originalExtraTotalHoursByModel = originalExtraTotalRows;
      this.originalSiteSelectionsByModel = this.cloneSelections(this.siteSelectionsByModel);
      this.originalExtraSelectionsByModel = this.cloneSelections(this.extraSelectionsByModel);
    },
    async saveHours(autosave = false) {
      const entries = this.getDirtyHourEntries();
      const visibilityEntries = this.getDirtyVisibilityEntries();
      if ((entries.length === 0 && visibilityEntries.length === 0) || !this.selectedPeriod) return;

      this.savingHours = true;
      try {
        await secureAxios.post('/api/hours/site-hours', {
          periodId: this.selectedPeriod,
          entries,
          visibilityEntries
        });
        entries.forEach(entry => {
          const index = this.hourDays.findIndex(day => day.iso === entry.date);
          if (entry.hourType === 'total_override') {
            if (entry.websiteId) {
              const site = this.getSiteById(entry.websiteId);
              const rowKey = this.getSiteRowKey(site, entry.hourLabel);
              if (!this.originalSiteTotalHoursByModel[entry.modelId]) this.originalSiteTotalHoursByModel[entry.modelId] = {};
              this.originalSiteTotalHoursByModel[entry.modelId][rowKey] = entry.deleteEntry
                ? ''
                : this.getSiteTotalOverride(entry.modelId, rowKey);
            } else {
              this.originalExtraTotalHoursByModel[entry.modelId] = entry.deleteEntry
                ? ''
                : this.getExtraTotalOverride(entry.modelId);
            }
          } else if (index !== -1) {
            if (entry.hourType === 'extra') {
              this.getOriginalExtraHours(entry.modelId)[index] = this.getExtraHours(entry.modelId)[index];
            } else {
              const site = this.getSiteById(entry.websiteId);
              const rowKey = this.getSiteRowKey(site, entry.hourLabel);
              this.getOriginalSiteHours(entry.modelId, rowKey)[index] = this.getSiteHours(entry.modelId, rowKey)[index];
            }
          }
        });
        this.originalSiteSelectionsByModel = this.cloneSelections(this.siteSelectionsByModel);
        this.originalExtraSelectionsByModel = this.cloneSelections(this.extraSelectionsByModel);
        if (!autosave) {
          toast.success('Hours saved');
        }
      } catch (error) {
        console.error('Error saving hours:', error?.message || error);
        toast.error(`Failed to ${autosave ? 'autosave' : 'save'} hours`);
      } finally {
        this.savingHours = false;
        if (this.unsavedCount > 0) {
          this.scheduleHoursAutosave?.();
        }
      }
    },
    setActiveCard(card) {
      this.activeCard = card;
    },
  },
};
</script>

<style scoped>
.active-card {
  border: 2px solid #1976d2 !important;
}

.hours-model-card {
  border-radius: 6px;
  margin-top: 16px;
  overflow: hidden;
}

.hours-model-header {
  align-items: center;
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  min-height: 52px;
  padding: 6px 12px;
}

.hours-model-name {
  color: #1f2937;
  font-size: 14px;
  font-weight: 700;
}

.hours-stage-name {
  background: #e3f2fd;
  border: 1px solid #bbdefb;
  border-radius: 999px;
  color: #1976d2;
  cursor: pointer;
  display: inline-block;
  justify-self: start;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  max-width: 220px;
  overflow: hidden;
  padding: 3px 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: fit-content;
}

.hours-stage-name:hover,
.hours-stage-name:focus-visible {
  background: #d6ebff;
  border-color: #90caf9;
  outline: none;
}

.hours-progress {
  display: grid;
  gap: 5px;
  margin-right: 12px;
  min-width: 150px;
}

.hours-progress-track {
  position: relative;
}

.hours-progress-marker {
  background: #1c2321;
  border-radius: 999px;
  height: 11px;
  width: 2px;
}

.hours-progress-marker-wrap {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 1px;
  position: absolute;
  top: -12px;
  transform: translateX(-50%);
  z-index: 2;
}

.hours-progress-marker-label {
  color: #1c2321 !important;
  font-size: 9px !important;
  font-weight: 700 !important;
  line-height: 1 !important;
}

.hours-period {
  color: #425166;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.hours-progress span {
  color: #1c2321;
  font-size: 12px;
  font-weight: 600;
}

.hours-filter-chip-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 14px;
  min-height: 28px;
}

.hours-filter-chip {
  border-radius: 999px !important;
  flex: 0 0 auto;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  max-width: 220px;
  width: fit-content;
}

.hours-filter-chip :deep(.v-chip__content) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hours-dashboard-card {
  border-radius: 12px;
  overflow: visible;
}

.hours-dashboard-card-collapsed {
  height: 48px;
  overflow: hidden;
}

.hours-dashboard-header {
  align-items: center;
  background: linear-gradient(180deg, #1c2321 0%, #3A4542 100%);
  border-radius: 12px 12px 0 0;
  color: white;
  display: flex;
  height: 48px;
  justify-content: space-between;
  padding: 12px 16px;
}

.hours-dashboard-actions {
  align-items: center;
  display: flex;
  gap: 10px;
}

.hours-dashboard-edit-btn {
  border-color: rgba(255, 255, 255, 0.8) !important;
  color: white !important;
  height: 30px;
  text-transform: none;
}

.hours-dashboard-cancel-btn {
  color: rgba(255, 255, 255, 0.88) !important;
  height: 30px;
  text-transform: none;
}

.hours-dashboard-title-wrap {
  align-items: center;
  display: flex;
  gap: 12px;
}

.hours-dashboard-title {
  color: white;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 1px;
}

.hours-dashboard-toggle {
  color: white;
  cursor: pointer;
}

.hours-dashboard-body {
  background: white;
  border-radius: 0 0 12px 12px;
  color: #1c2321;
  padding: 12px 16px 14px;
}

.hours-dashboard-reference {
  display: grid;
  gap: 12px;
}

.hours-pay-structure-panels {
  display: grid;
  gap: 18px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.hours-pay-structure-panel {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  overflow: hidden;
}

.hours-pay-structure-panel-title {
  align-items: center;
  background: #f8f8f8;
  border-bottom: 1px solid #e0e0e0;
  color: #1c2321;
  display: flex;
  font-size: 13px;
  font-weight: 800;
  justify-content: space-between;
  min-height: 30px;
  padding: 7px 10px;
}

.hours-pay-structure-panel-title small {
  color: #5f6b7a;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.hours-pay-structure-table {
  display: grid;
  grid-template-columns: 0.7fr 1fr 1fr;
}

.hours-pay-structure-skipped {
  align-items: center;
  background: #f7f9fc;
  color: #35506d;
  display: flex;
  gap: 12px;
  min-height: 171px;
  padding: 22px;
}

.hours-pay-structure-skipped div {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.hours-pay-structure-skipped strong {
  color: #20374f;
  font-size: 13px;
}

.hours-pay-structure-skipped span {
  color: #5f6b7a;
  font-size: 12px;
  font-weight: 600;
}

.hours-pay-structure-head,
.hours-pay-structure-cell {
  align-items: center;
  background: white;
  border-bottom: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
  color: #24302d;
  display: flex;
  font-size: 12px;
  font-weight: 600;
  justify-content: space-between;
  min-height: 28px;
  padding: 5px 10px;
}

.hours-pay-structure-head {
  background: #fbfcfd;
  color: #1c2321;
  font-weight: 800;
  justify-content: center;
}

.hours-pay-structure-cell:nth-last-child(-n + 3) {
  border-bottom: 0;
}

.hours-pay-structure-head:nth-child(3n),
.hours-pay-structure-cell:nth-child(3n) {
  border-right: 0;
}

.hours-pay-structure-input {
  max-width: 90px;
}

.hours-pay-structure-input :deep(input) {
  font-size: 12px;
  padding: 0;
  text-align: center;
}

.hours-calculator-card {
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  min-height: 180px;
}

.hours-calculator-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 4px 16px 14px !important;
}

.hours-calculator-inputs {
  display: grid;
  gap: 8px;
  grid-template-columns: 1fr 1fr;
}

.hours-calculator-result {
  align-items: center;
  background: #eef1f3;
  border-radius: 6px;
  color: #20262d;
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
  margin-left: auto;
  margin-right: auto;
  min-height: 34px;
  padding: 6px 10px;
  width: 52%;
}

.hours-calculator-result span {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}

.hours-calculator-copy {
  background: transparent;
  border: 0;
  color: #153e63;
  cursor: pointer;
  font-size: 18px;
  font-weight: 800;
  line-height: 1;
  padding: 2px 4px;
}

.hours-calculator-copy:hover,
.hours-calculator-copy:focus-visible {
  background: #dbeafe;
  border-radius: 4px;
  outline: none;
}

.hours-calculator-note {
  color: #5f6b7a;
  font-size: 12px;
  line-height: 1.25;
  margin-top: auto;
  padding-top: 10px;
}

.hours-period-actions {
  bottom: 0;
  gap: 18px;
  justify-content: center;
  margin-bottom: 12px;
  margin-top: -16px;
  position: absolute;
  width: 100%;
}

.hours-period-arrow {
  background: #1976d2 !important;
  color: white !important;
  height: 36px !important;
  width: 44px !important;
}

.hours-period-arrow:disabled {
  background: #d8e1ec !important;
  color: #8391a3 !important;
}

.hours-section-title {
  align-items: center;
  background: linear-gradient(180deg, #1c2321 0%, #3A4542 100%);
  border-radius: 6px;
  color: white;
  display: flex;
  height: 48px;
  justify-content: space-between;
  margin-top: 18px;
  padding: 12px 16px;
  position: sticky;
  top: 8px;
  z-index: 8;
}

.hours-section-title h2 {
  color: white;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.hours-title-with-help {
  align-items: center;
  display: flex;
  gap: 8px;
}

.hours-help-icon {
  color: rgba(255, 255, 255, 0.82);
  cursor: help;
}

.hours-help-icon:hover {
  color: white;
}

.hours-help-tooltip-card {
  display: grid;
  gap: 4px;
  font-size: 12px;
  line-height: 1.45;
  padding: 10px 12px;
  width: 320px;
}

.hours-help-tooltip-title {
  color: #153e63;
  font-weight: 800;
  margin-bottom: 2px;
}

.hours-section-title span {
  color: rgba(255, 255, 255, 0.82);
  font-size: 13px;
  font-weight: 600;
}

.hours-save-status {
  align-items: center;
  display: flex;
  gap: 12px;
}

.hours-dialog {
  border-radius: 6px;
}

.hours-dialog-title {
  align-items: center;
  display: flex;
  gap: 10px;
}

.hours-dialog-model {
  color: #2c74b3;
  font-size: 13px;
  font-weight: 600;
}

.hours-manage-sites-table th,
.hours-manage-sites-table td {
  text-align: center;
}

.hours-manage-sites-table th:first-child,
.hours-manage-sites-table td:first-child {
  text-align: left;
}

.hours-manage-pay-source-row td {
  background: #e8f2ff !important;
}

.hours-manage-not-applicable {
  color: #8a94a3;
  font-weight: 700;
}

.hours-manage-sites-note {
  color: #5f6b7a;
  font-size: 12px;
  line-height: 1.4;
  margin-top: 10px;
}

.hours-table-wrapper {
  overflow-x: auto;
}

.hours-card-tools {
  align-items: center;
  background: #ffffff;
  border-top: 1px solid #e5eaf0;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  min-height: 42px;
  padding: 6px 12px;
}

.hours-card-tool-btn {
  color: #425166 !important;
  font-size: 12px;
  font-weight: 700;
  text-transform: none;
}

.hours-card-tool-btn:hover {
  background: #f0f4f8 !important;
  color: #1976d2 !important;
}

.hours-card-tool-btn-active {
  background: #e3f2fd !important;
  color: #1976d2 !important;
}

.hours-diff-panel {
  background: #fbfcfe;
  border-top: 1px solid #e5eaf0;
}

.hours-diff-toolbar {
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  min-height: 48px;
  padding: 8px 12px;
}

.hours-diff-title {
  display: grid;
  gap: 1px;
  margin-right: auto;
}

.hours-diff-title span {
  color: #1c2321;
  font-size: 13px;
  font-weight: 800;
}

.hours-diff-title small {
  color: #687385;
  font-size: 11px;
  font-weight: 600;
}

.hours-diff-select {
  max-width: 230px;
  min-width: 210px;
}

.hours-diff-total {
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  min-width: 96px;
  padding: 5px 10px;
  text-align: center;
}

.hours-diff-table-wrapper {
  border-top: 1px solid #edf1f5;
}

.hours-diff-table :deep(table) {
  min-width: 1000px;
  table-layout: fixed;
}

.hours-diff-cell,
.hours-diff-total-cell {
  background: #ffffff !important;
  font-size: 12px;
  font-weight: 800;
}

.hours-diff-positive {
  color: #1976d2 !important;
}

.hours-diff-negative {
  color: #c62828 !important;
}

.hours-diff-zero {
  color: #738094 !important;
}

.hours-table :deep(table) {
  --hours-sales-blue: #f0f4f8;
  min-width: 1000px;
  table-layout: fixed;
}

.hours-table th {
  background: var(--hours-sales-blue);
  color: #20262d;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
}

.hours-metric-cell {
  background: #fafafa;
  width: 120px;
  min-width: 120px;
  padding-left: 16px !important;
  text-align: left !important;
  white-space: nowrap;
}

.hours-day-cell,
.hours-value-cell {
  min-width: 54px;
  padding-left: 0 !important;
  padding-right: 0 !important;
  text-align: center !important;
}

.hours-day-cell span,
.hours-day-cell small {
  display: block;
  text-align: center;
  width: 100%;
}

.hours-day-cell small {
  font-size: 10px;
  font-weight: 500;
}

.hours-report-cell {
  background: #fafafa;
}

.hours-pay-source-badge {
  background: #1976d2;
  border-radius: 999px;
  color: white;
  display: inline-flex;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  margin-left: 6px;
  padding: 3px 6px;
  vertical-align: middle;
}

.hours-extra-row .hours-metric-cell,
.hours-extra-row .hours-value-cell {
  background: #fbfaf2;
}

.hours-report-value {
  align-items: center;
  display: inline-flex;
  justify-content: center;
  margin: 0 auto;
  max-width: 48px;
  min-height: 32px;
  width: 48px;
}

.hours-value-cell {
  background: #fafafa;
  position: relative;
}

.hours-value-cell :deep(.v-field) {
  background: white;
}

.hours-comment-mode-cell {
  cursor: pointer;
}

.hours-comment-mode-cell:hover {
  box-shadow: inset 0 0 0 2px rgba(25, 118, 210, 0.28);
}

.hours-commented-cell::after {
  content: "";
  border-left: 8px solid transparent;
  border-top: 8px solid #1976d2;
  height: 0;
  position: absolute;
  right: 5px;
  top: 1px;
  width: 0;
  z-index: 2;
}

.hours-commented-cell:hover::before {
  background: #1c2321;
  border-radius: 4px;
  box-shadow: 0 8px 18px rgba(28, 35, 33, 0.18);
  color: white;
  content: attr(data-comment);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.35;
  max-width: 220px;
  min-width: 140px;
  padding: 7px 9px;
  position: absolute;
  right: 2px;
  text-align: left;
  top: -8px;
  transform: translateY(-100%);
  white-space: normal;
  z-index: 10;
}

.hours-empty-cell {
  display: inline-block;
  min-height: 32px;
  width: 48px;
}

.hours-total-cell {
  background: var(--hours-sales-blue);
  color: #1976d2;
  font-weight: 700;
  max-width: 62px;
  min-width: 62px;
  padding-left: 4px !important;
  padding-right: 4px !important;
  text-align: center;
  white-space: nowrap;
  width: 62px;
}

.hours-total-report {
  color: #1c2321;
}

.hours-total-extra {
  color: #6f4e00;
  font-weight: 800;
}

.hours-paid-row .hours-metric-cell,
.hours-paid-cell,
.hours-total-paid {
  background: var(--hours-sales-blue) !important;
  color: #1c2321;
  font-weight: 800;
}

.hours-paid-value {
  align-items: center;
  display: inline-flex;
  justify-content: center;
  min-height: 32px;
}

.hours-total-low {
  color: #c62828;
}

.hours-total-warning {
  color: #d18f00;
}

.hours-total-good {
  color: #2e7d32;
}

.hours-entry {
  margin: 0 auto;
  max-width: 48px;
  width: 48px;
}

.hours-entry :deep(.v-field) {
  min-height: 32px;
}

.hours-entry-dirty :deep(.v-field) {
  background: #fff8d7 !important;
  border-color: #d9a900 !important;
}

.hours-entry :deep(input) {
  appearance: textfield;
  -moz-appearance: textfield;
  font-size: 13px;
  padding: 0;
  text-align: center !important;
}

.hours-total-entry {
  max-width: 52px;
  width: 52px;
}

.hours-total-entry :deep(.v-field) {
  min-height: 30px;
}

.hours-total-entry :deep(input) {
  font-size: 12px;
  font-weight: 700;
}

.hours-total-entry :deep(.v-field__input) {
  min-height: 30px;
}

.hours-entry :deep(input::-webkit-inner-spin-button),
.hours-entry :deep(input::-webkit-outer-spin-button) {
  -webkit-appearance: none;
  margin: 0;
}

.hours-entry :deep(.v-field__input) {
  justify-content: center;
  padding-inline: 0;
  text-align: center !important;
}

</style>
